var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-body" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawer,
            direction: "ttb",
            "show-close": false,
            size: "100%",
            withHeader: false,
            "destroy-on-close": true,
            "before-close": _vm.handleClose
          }
        },
        [
          _vm.type === 1
            ? [
                _c(
                  "div",
                  {
                    staticClass: "pendingOrder",
                    on: { keyup: _vm.monitorInput }
                  },
                  [
                    _c("div", { staticClass: "close" }, [
                      _c("div", { staticClass: "singInfo" }, [
                        _c("span", [
                          _vm._v("挂单 "),
                          _c("i", [
                            _vm._v(_vm._s(_vm.orderDataHasBeenPosted.length))
                          ]),
                          _vm._v(" 张")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "singleNumberInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.odd,
                                expression: "odd"
                              }
                            ],
                            ref: "singleNumberInputRef",
                            attrs: { type: "number", placeholder: "手牌号" },
                            domProps: { value: _vm.odd },
                            on: {
                              blur: function($event) {
                                return _vm.handCheckList(_vm.odd)
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.odd = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "iconfont icon-guanbi",
                            on: {
                              click: function($event) {
                                _vm.handCheckList((_vm.odd = ""))
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "timeBox" },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "range-separator": "至",
                              type: "daterange",
                              "append-to-body": true,
                              size: "mini",
                              editable: false,
                              "value-format": "yyyy-MM-dd",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期"
                            },
                            on: {
                              change: function($event) {
                                return _vm.$emit("getTheListOfOrderingData", {
                                  dataTime: _vm.checkOrdersByDate,
                                  key: _vm.odd
                                })
                              }
                            },
                            model: {
                              value: _vm.checkOrdersByDate,
                              callback: function($$v) {
                                _vm.checkOrdersByDate = $$v
                              },
                              expression: "checkOrdersByDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("i", { staticStyle: { color: "#7a7a7a" } }, [
                        _vm._v("合单时以首选单为主单！")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "operation" }, [
                        _c(
                          "div",
                          {
                            class: _vm.combinedSingularStat ? "active" : "",
                            on: { click: _vm.consolidateOrders }
                          },
                          [
                            _c("span", { staticClass: "iconfont icon-hebing" }),
                            _vm._v(" "),
                            _c("span", [_vm._v("合并")])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { on: { click: _vm.handleClose } }, [
                          _c("span", { staticClass: "iconfont icon-guanbi" })
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content-order" },
                      _vm._l(_vm.pendingOrderList, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            class: item.memberId
                              ? "content-order-item active"
                              : "content-order-item"
                          },
                          [
                            _c("div", { staticClass: "singleEnd" }, [
                              _c("span", [
                                _c(
                                  "i",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.handBrand,
                                        expression: "item.handBrand"
                                      }
                                    ],
                                    staticStyle: { "font-size": "20px" },
                                    on: {
                                      click: function($event) {
                                        return _vm.updateTheHandNumber(item)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(item.handBrand))]
                                ),
                                _vm._v(" "),
                                _c("i", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.resource === 1,
                                      expression: "item.resource === 1"
                                    }
                                  ],
                                  class: item.handBrand
                                    ? "iconfont icon-weixin"
                                    : "iconfont icon-bianhao",
                                  style: item.handBrand
                                    ? {
                                        fontSize: "24px",
                                        color: "rgb(0, 200, 0)"
                                      }
                                    : {
                                        fontSize: "24px",
                                        color: "rgb(204, 0, 153)"
                                      },
                                  on: {
                                    click: function($event) {
                                      return _vm.updateTheHandNumber(item)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "i",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.memberName,
                                        expression: "item.memberName"
                                      }
                                    ],
                                    staticClass: "member-name",
                                    staticStyle: { color: "rgb(0, 200, 0)" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("nameMask")(item.memberName)
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "i",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.memberId,
                                        expression: "item.memberId"
                                      }
                                    ],
                                    staticStyle: {
                                      "text-decoration": "underline",
                                      color: "rgb(169, 119, 2)"
                                    }
                                  },
                                  [_vm._v(_vm._s(item.memberMobile))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "i",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          item.resource !== 1 && !item.memberId,
                                        expression:
                                          "item.resource !== 1 && !item.memberId"
                                      }
                                    ]
                                  },
                                  [_vm._v("散客单")]
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", {
                                class: item.sign ? "active" : "",
                                on: {
                                  click: function($event) {
                                    return _vm.updateTag(item)
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "orderNo" }, [
                              _c("span", [_vm._v("订单号:")]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.orderNo))])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "orderTime" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm._f("dateType")(item.addDate)))
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _c("i", {
                                  staticClass: "iconfont icon-daojishi"
                                }),
                                _vm._v(" "),
                                _c("i", [
                                  _vm._v(_vm._s(_vm.orderTimeTiming[index]))
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "informationOfEmployees" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "slide" },
                                  _vm._l(
                                    _vm.employeeWeightRemoval(item.employeeMap),
                                    function(employeeItem, index) {
                                      return _c(
                                        "span",
                                        {
                                          key: index,
                                          style: item.memberId
                                            ? { color: "#00ff37" }
                                            : { color: "#20993a" }
                                        },
                                        [
                                          _c("i", [
                                            _vm._v(
                                              _vm._s(employeeItem.employeeNo)
                                            )
                                          ]),
                                          _vm._v(
                                            _vm._s(employeeItem.employeeName)
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "unitPriceSheet" }, [
                              _c(
                                "table",
                                { attrs: { cellspacing: "0" } },
                                [
                                  _c("tr", [
                                    _c("td", [_vm._v("品项")]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v("原价")])
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(item.torderPpItems, function(items) {
                                    return _c("tr", { key: items.id }, [
                                      _c("td", [
                                        _vm._v(_vm._s(items.itemName))
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("amountType")(items.price)
                                          )
                                        )
                                      ])
                                    ])
                                  }),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c("td", { attrs: { colspan: "2" } }, [
                                      _vm._v("\n                    合计："),
                                      _c(
                                        "i",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("amountType")(
                                                _vm.totalOrderPrice(
                                                  item.torderPpItems
                                                )
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "operation" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "background-color":
                                      "rgba(229, 229, 229, 0.83)"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.cancellationOfOrder(item.id)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "iconfont icon-shanchu1"
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.handleTakeOrder(item)
                                    }
                                  }
                                },
                                [_vm._v("取单")]
                              )
                            ])
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "employeeData" },
                      _vm._l(_vm.pendingEmployee, function(item) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            class:
                              _vm.idOfTheCurrentlySelectedEmployee === item.id
                                ? "employeeData-time active"
                                : "employeeData-time",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.inquireOrdersAccordingToStaff(
                                  item.id
                                )
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "quantity" }, [
                              _vm._v(_vm._s(item.num))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "content" }, [
                              _c("span", [_vm._v(_vm._s(item.employeeName))]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.employeeNo))])
                            ])
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "el-drawer",
                      {
                        attrs: {
                          visible: _vm.dateFilteringPopsUp,
                          direction: "btt",
                          size: "45%",
                          withHeader: false,
                          "append-to-body": true
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.dateFilteringPopsUp = $event
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "dateSelector" },
                          [
                            _c("timeHorizon", {
                              model: {
                                value: _vm.checkOrdersByDate,
                                callback: function($$v) {
                                  _vm.checkOrdersByDate = $$v
                                },
                                expression: "checkOrdersByDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "选择手牌号",
                          visible: _vm.theHandNumberPopsUp,
                          "append-to-body": true,
                          "custom-class": "handNumberScreeningClose",
                          "before-close": _vm.closeTheHandNumber,
                          width: "70%"
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.theHandNumberPopsUp = $event
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "handNumberScreening" },
                          _vm._l(_vm.defaultHandNumber, function(item) {
                            return _c(
                              "span",
                              {
                                key: item.hand,
                                class:
                                  _vm.occupied.indexOf(item.hand) !== -1
                                    ? "active"
                                    : "",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.changeHand(item.hand)
                                  }
                                }
                              },
                              [_vm._v(" #" + _vm._s(item.hand) + " ")]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "manualInput" }, [
                          _c("span", [_vm._v("手动输入手牌号")]),
                          _vm._v(" "),
                          _c("span", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.addOdd,
                                  expression: "addOdd"
                                }
                              ],
                              attrs: {
                                type: "text",
                                maxlength: "3",
                                placeholder: "请输入手牌号",
                                oninput: "value=value.replace(/[^0-9.]/g,'')"
                              },
                              domProps: { value: _vm.addOdd },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.addOdd = $event.target.value
                                }
                              }
                            }),
                            _c(
                              "i",
                              {
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.changeHand(_vm.addOdd)
                                  }
                                }
                              },
                              [_vm._v("确定")]
                            )
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.type === 2
            ? [
                _c(
                  "div",
                  { staticClass: "memberTopUp" },
                  [
                    _c("div", { staticClass: "close" }, [
                      _c("div", { staticClass: "singInfo" }, [
                        _c("span", [_vm._v("会员充值")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "mies",
                            on: {
                              click: function($event) {
                                _vm.isMies = !_vm.isMies
                              }
                            }
                          },
                          [
                            _c("span", { class: _vm.isMies ? "active" : "" }),
                            _vm._v(" "),
                            _c("span", [_vm._v("发送消费信息")])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "orderTrackingNumber" }, [
                          _c("span", [_vm._v("客数：")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "border_color",
                                rawName: "v-border_color"
                              },
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: _vm.customerCount,
                                expression: "customerCount",
                                modifiers: { number: true }
                              }
                            ],
                            staticStyle: {
                              width: "50px",
                              "margin-right": "10px"
                            },
                            attrs: {
                              type: "text",
                              oninput: "value=value.replace(/[^0-9.]/g,'')"
                            },
                            domProps: { value: _vm.customerCount },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.customerCount = _vm._n($event.target.value)
                              },
                              blur: function($event) {
                                return _vm.$forceUpdate()
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "orderTrackingNumber" }, [
                          _c("span", [_vm._v("流水单号：")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "border_color",
                                rawName: "v-border_color"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.billNumber,
                                expression: "billNumber"
                              }
                            ],
                            attrs: {
                              type: "text",
                              placeholder: "请输入流水单号",
                              oninput: "value=value.replace(/[^0-9.]/g,'')"
                            },
                            domProps: { value: _vm.billNumber },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.billNumber = $event.target.value
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "operation" }, [
                        _c(
                          "div",
                          {
                            class: _vm.whetherTheTopUpOrderIsPayable
                              ? "active"
                              : "",
                            on: { click: _vm.confirmRecharge }
                          },
                          [
                            _c("span", {
                              staticClass: "iconfont icon-jiesuan"
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("确认充值")])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { on: { click: _vm.handleClose } }, [
                          _c("span", { staticClass: "iconfont icon-guanbi" })
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "rechargeBody" }, [
                      _c(
                        "div",
                        { staticClass: "rechargeBody-left" },
                        [
                          _c("div", { staticClass: "inputContent" }, [
                            _c("div", { staticClass: "inputContent-item" }, [
                              _c("span", [_vm._v("充值金额：")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "border_color",
                                    rawName: "v-border_color"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.rechargeObject.rechargeAmount,
                                    expression: "rechargeObject.rechargeAmount",
                                    modifiers: { trim: true }
                                  }
                                ],
                                attrs: {
                                  type: "text",
                                  onfocus: "this.select()",
                                  oninput: "value=value.replace(/[^0-9.]/g,'')"
                                },
                                domProps: {
                                  value: _vm.rechargeObject.rechargeAmount
                                },
                                on: {
                                  keyup: _vm.defaultRechargeAmount,
                                  blur: [
                                    _vm.calculateTheTopUpPerformance,
                                    function($event) {
                                      return _vm.$forceUpdate()
                                    }
                                  ],
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.rechargeObject,
                                      "rechargeAmount",
                                      $event.target.value.trim()
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "inputContent-item" }, [
                              _c("span", [_vm._v("赠送金额：")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.rechargeObject.amountOfGift,
                                    expression: "rechargeObject.amountOfGift",
                                    modifiers: { trim: true }
                                  }
                                ],
                                attrs: {
                                  type: "text",
                                  onfocus: "this.select()",
                                  oninput: "value=value.replace(/[^0-9.]/g,'')"
                                },
                                domProps: {
                                  value: _vm.rechargeObject.amountOfGift
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.rechargeObject,
                                      "amountOfGift",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function($event) {
                                    return _vm.$forceUpdate()
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "inputContent-item" },
                              [
                                [
                                  _c("span", [_vm._v("优惠金额：")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.trim",
                                        value:
                                          _vm.rechargeObject.discountAmount,
                                        expression:
                                          "rechargeObject.discountAmount",
                                        modifiers: { trim: true }
                                      }
                                    ],
                                    attrs: {
                                      type: "text",
                                      onfocus: "this.select()",
                                      oninput:
                                        "value=value.replace(/[^0-9.]/g,'')"
                                    },
                                    domProps: {
                                      value: _vm.rechargeObject.discountAmount
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.rechargeObject,
                                          "discountAmount",
                                          $event.target.value.trim()
                                        )
                                      },
                                      blur: function($event) {
                                        return _vm.$forceUpdate()
                                      }
                                    }
                                  })
                                ]
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _vm.transferCardInformation
                            ? [
                                _c("div", { staticClass: "transferCardInfo" }, [
                                  _c("span", [
                                    _c("i", {
                                      staticClass: "iconfont icon-chacha",
                                      on: {
                                        click: function($event) {
                                          _vm.transferCardInformation = null
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("i", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.transferCardInformation.cardName
                                        )
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            : [
                                _vm.membershipCardTransferList.length <= 0
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "transferCard" },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "iconfont icon-zhuanhuan active"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "active" },
                                            [_vm._v("会员升降卡")]
                                          )
                                        ]
                                      )
                                    ]
                                  : [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "transferCard",
                                          on: {
                                            click: function($event) {
                                              return _vm.openTransferCard(
                                                true,
                                                _vm.currentlySelectedCard
                                                  .tmemberCard.tenantCardId
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "iconfont icon-zhuanhuan"
                                          }),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("会员升降卡")])
                                        ]
                                      )
                                    ]
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "rechargeBody-right" }, [
                        _c("div", { staticClass: "memberInformation" }, [
                          _c("div", { staticClass: "membertitle" }, [
                            _c("span", {
                              staticClass: "iconfont icon-huiyuanqiaguanli"
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(" 会员卡详情")])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "cardInformation" },
                            [
                              [
                                _c("div", { staticClass: "otherOperations" }, [
                                  _c(
                                    "div",
                                    { staticClass: "card-Info-content" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "card-title" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "card-info-name" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentlySelectedCard
                                                      .tmemberCard.cardName
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentlySelectedCard
                                                      .tmemberCard.cardTypeName
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "cardBalance" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "kagin" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cardBalance-content"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v("卡余额:")
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "amountType"
                                                              )(
                                                                Number(
                                                                  _vm
                                                                    .currentlySelectedCard
                                                                    .tmemberCard
                                                                    .initAmount
                                                                ) +
                                                                  Number(
                                                                    _vm
                                                                      .currentlySelectedCard
                                                                      .tmemberCard
                                                                      .givenAmount
                                                                  )
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "kagin-content"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v("本金:")
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "amountType"
                                                              )(
                                                                _vm
                                                                  .currentlySelectedCard
                                                                  .tmemberCard
                                                                  .initAmount
                                                              )
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v("赠金:")
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "amountType"
                                                              )(
                                                                _vm
                                                                  .currentlySelectedCard
                                                                  .tmemberCard
                                                                  .givenAmount
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "availabilityPeriod" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "cardRemarks" },
                                            [
                                              _c("span", [_vm._v("卡备注：")]),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "text-overflow": "ellipsis",
                                                    "white-space": "nowrap",
                                                    overflow: "hidden"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.currentlySelectedCard
                                                        .tmemberCard.remark
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "periodOfValidity" },
                                            [
                                              _c("span", [_vm._v("有效期：")]),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f(
                                                      "filterCalculationCardValidityPeriod"
                                                    )(
                                                      _vm.currentlySelectedCard
                                                        .tmemberCard
                                                        .effectiveDays
                                                    )
                                                  ) + "期"
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "Sub-card-item-yuangong" }, [
                          _c("div", { staticClass: "List-of-sub-card-items" }, [
                            _c(
                              "div",
                              {
                                staticClass: "addOnSales",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.addTopUpStaff.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [
                                _c("span", {
                                  staticClass: "iconfont icon-a-xiaoshou2"
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _c(
                                    "i",
                                    {
                                      staticStyle: {
                                        "font-size": "18px",
                                        "font-weight": "bold"
                                      }
                                    },
                                    [_vm._v("+")]
                                  ),
                                  _vm._v("充值员工")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "vessel" },
                              _vm._l(_vm.topUpSalesStaffList, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "market" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(item.employeeName))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "market-info" }, [
                                      _c("span", [_vm._v("销售")]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        [
                                          item.achievement
                                            ? [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: item.achievement,
                                                      expression:
                                                        "item.achievement"
                                                    }
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    disabled:
                                                      _vm.whetherToDisablePerformanceModification ||
                                                      item.brokerageClass ===
                                                        "no",
                                                    onfocus: "this.select()"
                                                  },
                                                  domProps: {
                                                    value: item.achievement
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        item,
                                                        "achievement",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            : [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: item.percentage,
                                                      expression:
                                                        "item.percentage"
                                                    }
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    disabled:
                                                      _vm.whetherToDisablePerformanceModification ||
                                                      item.brokerageClass ===
                                                        "no",
                                                    onfocus: "this.select()"
                                                  },
                                                  domProps: {
                                                    value: item.percentage
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        item,
                                                        "percentage",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                          _vm._v(" "),
                                          item.brokerageClass !== "no"
                                            ? _c("i", {
                                                staticClass:
                                                  "iconfont icon-bianji1"
                                              })
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "iconfont icon-closel",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.removeAnEmployee(index)
                                        }
                                      }
                                    })
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.departmentList === 1
                          ? _c(
                              "div",
                              {
                                staticClass: "achievements",
                                staticStyle: {
                                  "padding-left": "0",
                                  "padding-top": "10px"
                                }
                              },
                              [
                                _c("span", [_vm._v("部门业绩:")]),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "assigned" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "padding-right": "10px",
                                            height: "28px",
                                            "line-height": "24px"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "f20 text-primary" },
                                            [_vm._v("【")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.isDepartmentalPerformance,
                                        function(item) {
                                          return _c(
                                            "div",
                                            {
                                              key: item.departmentId,
                                              staticStyle: {
                                                "padding-right": "5px"
                                              }
                                            },
                                            [
                                              item.departmentName !== ""
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-primary"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.departmentName
                                                            ) + ": "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("el-input", {
                                                        staticStyle: {
                                                          width: "50px"
                                                        },
                                                        attrs: {
                                                          size: "mini",
                                                          oninput:
                                                            _vm.onInputNumPoint
                                                        },
                                                        model: {
                                                          value:
                                                            item.achievement,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "achievement",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.achievement"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "f20 text-primary" },
                                        [_vm._v("】")]
                                      )
                                    ],
                                    2
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "particulars" }, [
                          _c("div", { staticClass: "particulars-title" }, [
                            _c("span", {
                              staticClass: "iconfont icon-dingdan"
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("付款方式")])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "order-content" },
                            _vm._l(_vm.clearingForm, function(item) {
                              return _c(
                                "div",
                                {
                                  key: item.iconfont,
                                  staticClass: "order-content-item",
                                  on: {
                                    click: function($event) {
                                      return _vm.topUpPaymentAmount(item)
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "typeOfPayment" }, [
                                    _c("span", [
                                      _c(
                                        "svg",
                                        {
                                          staticClass: "icon",
                                          attrs: { "aria-hidden": "true" }
                                        },
                                        [
                                          _c("use", {
                                            attrs: { href: "#" + item.iconfont }
                                          })
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(item.name))]),
                                    _vm._v(" "),
                                    item.paymentAmount > 0
                                      ? _c(
                                          "span",
                                          {
                                            class:
                                              item.name === "智慧支付" &&
                                              _vm.globalPaymentStatus === "1"
                                                ? "money active"
                                                : "money"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("amountType")(
                                                  item.paymentAmount
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "adjustedPayment" }, [
                            _c("div", { staticClass: "cutOffRule" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "order-content-item",
                                on: { click: _vm.adjustedPayment }
                              },
                              [
                                _c("div", { staticClass: "typeOfPayment" }, [
                                  _c("span", [
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "icon",
                                        attrs: { "aria-hidden": "true" }
                                      },
                                      [
                                        _c("use", {
                                          attrs: { href: "#icon-hunhe" }
                                        })
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("调整支付")])
                                ])
                              ]
                            )
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-drawer",
                      {
                        attrs: {
                          "append-to-body": true,
                          size: "40%",
                          "show-close": false,
                          withHeader: false,
                          "before-close": _vm.innerDrawerHandleClose,
                          visible: _vm.innerDrawer
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.innerDrawer = $event
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "mixedPayment" }, [
                          _c("div", { staticClass: "mixedPayment-title" }, [
                            _c("span", [
                              _vm._v("支付详情，共需支付："),
                              _c("i", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("amountType")(_vm.settlementAmount)
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "iconfont icon-guanbi",
                              on: { click: _vm.innerDrawerHandleClose }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "modeOfPaymentList" },
                            _vm._l(_vm.modifyPaymentAmount, function(item) {
                              return _c(
                                "div",
                                {
                                  key: item.name,
                                  staticClass: "modeOfPaymentList-item topUp"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: { "white-space": "nowrap" }
                                    },
                                    [_vm._v(_vm._s(item.name) + ":")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: item.money,
                                        expression: "item.money"
                                      }
                                    ],
                                    attrs: {
                                      type: "text",
                                      oninput:
                                        "value=value.replace(/[^0-9.]/g,'')"
                                    },
                                    domProps: { value: item.money },
                                    on: {
                                      blur: _vm.excessOfAmount,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          item,
                                          "money",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  item.name === "智慧支付"
                                    ? [
                                        _c(
                                          "span",
                                          { on: { click: _vm.smartPayment } },
                                          [_vm._v("支付")]
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            }),
                            0
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          visible: _vm.topUpEmployeeShow,
                          width: "50%",
                          title: "选择员工",
                          "append-to-body": true,
                          "close-delay": false,
                          "before-close": _vm.closeTheMembershipScreeningPopup
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.topUpEmployeeShow = $event
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "employeeList" }, [
                          _c(
                            "div",
                            {
                              staticClass: "confirm",
                              on: {
                                click: function($event) {
                                  return _vm.firmChangeOrder("topUp")
                                }
                              }
                            },
                            [_vm._v("确定")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dataBox" },
                            _vm._l(_vm.topUpEmployeeList, function(item) {
                              return _c(
                                "div",
                                { key: item.postName, staticClass: "con" },
                                [
                                  _c("div", { staticClass: "position" }, [
                                    _c("span", {
                                      staticClass: "iconfont icon-zhiwei"
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(item.postName))])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "staff" },
                                    _vm._l(item.employeeDataList, function(
                                      subItem
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: subItem.id,
                                          class: subItem.label
                                            ? "staff-item active"
                                            : "staff-item",
                                          on: {
                                            click: function($event) {
                                              return _vm.addATopUpCardForSale(
                                                subItem
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(subItem.employeeNo))
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(subItem.employeeName))
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [
                                            _c(
                                              "i",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: subItem.num,
                                                    expression: "subItem.num"
                                                  }
                                                ]
                                              },
                                              [_vm._v(_vm._s(subItem.num))]
                                            ),
                                            _vm._v(" "),
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: subItem.num,
                                                  expression: "subItem.num"
                                                }
                                              ],
                                              staticClass:
                                                "iconfont icon-chacha",
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.deleteEmployeeData(
                                                    subItem.id
                                                  )
                                                }
                                              }
                                            })
                                          ])
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          visible: _vm.memberTransferCardBoxShow,
                          width: "680px",
                          title: "选择会员卡",
                          "append-to-body": true,
                          "before-close": _vm.closeTheMembershipScreeningPopup
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.memberTransferCardBoxShow = $event
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "membershipCardBox" },
                          _vm._l(_vm.membershipCardTransferList, function(
                            item
                          ) {
                            return _c(
                              "div",
                              {
                                key: item.id,
                                class: item.sign
                                  ? "member-card-item active"
                                  : "member-card-item",
                                on: {
                                  click: function($event) {
                                    return _vm.selectTransferCardRechargeCard(
                                      item
                                    )
                                  }
                                }
                              },
                              [
                                _c("span", [_vm._v(_vm._s(item.cardName))]),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(item.cardNo))])
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-drawer",
                      {
                        attrs: {
                          "append-to-body": true,
                          size: "40%",
                          "show-close": true,
                          withHeader: false,
                          "before-close": _vm.closeTheScanCodePaymentWindow,
                          visible: _vm.intelligentPaymentState
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.intelligentPaymentState = $event
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "smartPayment" }, [
                          _c("div", { staticClass: "wisdomPaysTitle" }, [
                            _c("span", [_vm._v("您当前正在通过")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "paymentMethodDetails" },
                              [
                                _c("span", [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "icon",
                                      attrs: { "aria-hidden": "true" }
                                    },
                                    [
                                      _c("use", {
                                        attrs: { href: "#icon-shoukuan" }
                                      })
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v("智慧支付")]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.innerDrawer,
                                        expression: "!innerDrawer"
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("amountType")(
                                          _vm.clearingForm.reduce(function(
                                            pv,
                                            cu
                                          ) {
                                            if (cu.name === "智慧支付") {
                                              return _vm.accuracyCheck(
                                                pv,
                                                cu.paymentAmount
                                              )
                                            } else {
                                              return pv
                                            }
                                          },
                                          0)
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.innerDrawer,
                                        expression: "innerDrawer"
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("amountType")(
                                          _vm.modifyPaymentAmount.reduce(
                                            function(pv, cu) {
                                              if (cu.name === "智慧支付") {
                                                return _vm.accuracyCheck(
                                                  pv,
                                                  cu.money
                                                )
                                              } else {
                                                return pv
                                              }
                                            },
                                            0
                                          )
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "paymentModeSwitching" }, [
                            _c(
                              "span",
                              {
                                class:
                                  _vm.smartPaymentMethod === "0"
                                    ? "active"
                                    : "",
                                on: {
                                  click: function($event) {
                                    return _vm.switchingPaymentMethods(
                                      "0",
                                      "topUp"
                                    )
                                  }
                                }
                              },
                              [_vm._v("商家扫码收款")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                class:
                                  _vm.smartPaymentMethod === "1"
                                    ? "active"
                                    : "",
                                on: {
                                  click: function($event) {
                                    return _vm.switchingPaymentMethods(
                                      "1",
                                      "topUp"
                                    )
                                  }
                                }
                              },
                              [_vm._v("顾客扫码收款")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "collectionContents" }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.smartPaymentMethod === "0",
                                    expression: "smartPaymentMethod === '0'"
                                  }
                                ],
                                staticClass: "merchantScanningCode"
                              },
                              [
                                _c("div", { staticClass: "paymentContent" }, [
                                  _c("input", {
                                    ref: "scanToPay",
                                    attrs: {
                                      type: "text",
                                      placeholder: "请使用扫码枪扫码输入",
                                      oninput:
                                        "value=value.replace(/[^0-9.]/g,'')"
                                    },
                                    domProps: { value: _vm.codeNumber },
                                    on: { keydown: _vm.scanCodeGunInput }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("支付")])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.smartPaymentMethod === "1",
                                    expression: "smartPaymentMethod === '1'"
                                  }
                                ],
                                staticClass: "customerScanCode"
                              },
                              [
                                _c("div", { staticClass: "paymentContent" }, [
                                  _c(
                                    "div",
                                    { staticClass: "payBox" },
                                    [
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.paymentCardPaymentAddress,
                                            alt: "暂无开通拉卡拉"
                                          }
                                        })
                                      ],
                                      _vm._v(" "),
                                      _vm.payState === 100
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "payImg" },
                                              [
                                                _c("span", {
                                                  staticClass:
                                                    "iconfont icon-zhifuchenggong"
                                                }),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("支付中")])
                                              ]
                                            )
                                          ]
                                        : _vm.payState === 300
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "payImg" },
                                              [
                                                _c("span", {
                                                  staticClass:
                                                    "iconfont icon-qunfengzhifuchenggong"
                                                }),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("支成功")])
                                              ]
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "payInfo" }, [
                                    _c("span", [_vm._v("扫码支付")]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v("请顾客使用微信或支付宝扫此二维码")
                                    ])
                                  ])
                                ])
                              ]
                            )
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.type === 3
            ? [
                _c(
                  "div",
                  {
                    staticClass: "pendingOrder",
                    on: { keyup: _vm.monitorInput }
                  },
                  [
                    _c("div", { staticClass: "close" }, [
                      _c("div", { staticClass: "singInfo" }, [
                        _c("div", { staticClass: "gender" }, [
                          _c("div", { staticClass: "sexSelection" }, [
                            _c(
                              "div",
                              {
                                class:
                                  _vm.memberSex === 1
                                    ? "sexSelection-item active"
                                    : "sexSelection-item"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function($event) {
                                        _vm.memberSex = 1
                                      }
                                    }
                                  },
                                  [_vm._v("男")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class:
                                  _vm.memberSex === 0
                                    ? "sexSelection-item active"
                                    : "sexSelection-item"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function($event) {
                                        _vm.memberSex = 0
                                      }
                                    }
                                  },
                                  [_vm._v("女")]
                                )
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isIndividualTraveler,
                                expression: "isIndividualTraveler"
                              }
                            ],
                            staticClass: "mies",
                            on: {
                              click: function($event) {
                                _vm.isMies = !_vm.isMies
                              }
                            }
                          },
                          [
                            _c("span", { class: _vm.isMies ? "active" : "" }),
                            _vm._v(" "),
                            _c("span", [_vm._v("发送消费信息")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "orderTrackingNumber",
                            staticStyle: { position: "relative" }
                          },
                          [
                            _c("div", { staticClass: "orderTrackingNumber" }, [
                              _c("span", [_vm._v("客数：")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "border_color",
                                    rawName: "v-border_color"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.customerCount,
                                    expression: "customerCount",
                                    modifiers: { number: true }
                                  }
                                ],
                                staticStyle: {
                                  width: "50px",
                                  "margin-right": "10px"
                                },
                                attrs: {
                                  type: "text",
                                  oninput: "value=value.replace(/[^0-9.]/g,'')"
                                },
                                domProps: { value: _vm.customerCount },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.customerCount = _vm._n(
                                      $event.target.value
                                    )
                                  },
                                  blur: function($event) {
                                    return _vm.$forceUpdate()
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "padding-left": "30px" } },
                              [_vm._v("流水单号：")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "border_color",
                                  rawName: "v-border_color"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.billNumber,
                                  expression: "billNumber"
                                }
                              ],
                              staticStyle: {
                                width: "110px",
                                "font-size": "13px"
                              },
                              attrs: {
                                type: "text",
                                placeholder: "请输入流水单号",
                                oninput: "value=value.replace(/[^0-9.]/g,'')"
                              },
                              domProps: { value: _vm.billNumber },
                              on: {
                                keyup: _vm.OnBillNumber,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.billNumber = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.RunningOrdersShow,
                                    expression: "RunningOrdersShow"
                                  }
                                ],
                                class: {
                                  repatInput: _vm.RunningOrdersShow == true,
                                  isShowx:
                                    _vm.RunningOrdersText != "该流水单号已录入"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.RunningOrdersText) +
                                    "\n                "
                                ),
                                _c("div", {
                                  class: {
                                    repatInputafter: _vm.RunningOrdersShow,
                                    isShowx:
                                      _vm.RunningOrdersText !=
                                      "该流水单号已录入"
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "operation" }, [
                        _c(
                          "div",
                          {
                            class: _vm.whetherItIsPayableOrNot ? "active" : "",
                            on: { click: _vm.tallyOrder }
                          },
                          [
                            _c("span", {
                              staticClass: "iconfont icon-jiesuan"
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("结算")])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { on: { click: _vm.handleClose } }, [
                          _c("span", { staticClass: "iconfont icon-guanbi" })
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "clearingForm",
                        staticStyle: { height: "auto" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-wrap": "wrap"
                            }
                          },
                          [
                            _c("div", { staticClass: "title-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "title-content-item",
                                  staticStyle: { "margin-right": "0px" }
                                },
                                [
                                  _c("span", {
                                    staticClass: "iconfont icon-yingfu"
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("订单金额：")]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("amountType")(_vm.amountInTotal)
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "i",
                                {
                                  staticClass: "text-primary f20",
                                  staticStyle: { color: "#1E90FF" }
                                },
                                [_vm._v("【")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "title-content-item" }, [
                                _c("span", [_vm._v("付现：")]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("amountType")(
                                        _vm.amountInTotal -
                                          _vm.amountOfConsumableCard -
                                          _vm.settlementAllowance
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "title-content-item" }, [
                                _c("span", [_vm._v("可耗卡：")]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("amountType")(
                                        _vm.amountOfConsumableCard
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "title-content-item",
                                  staticStyle: { margin: "0" }
                                },
                                [
                                  _c("span", [_vm._v("优惠金额：")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.settlementAllowance,
                                        expression: "settlementAllowance"
                                      }
                                    ],
                                    staticStyle: {
                                      width: "110px",
                                      height: "28px",
                                      border: "1px solid rgb(232, 232, 232)",
                                      padding: "0 10px",
                                      "box-sizing": "border-box",
                                      "border-radius": "5px"
                                    },
                                    attrs: {
                                      type: "text",
                                      onfocus: "this.select()",
                                      oninput:
                                        "value=value.replace(/[^0-9.]/g,'')"
                                    },
                                    domProps: {
                                      value: _vm.settlementAllowance
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.settlementAllowance =
                                          $event.target.value
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "i",
                                {
                                  staticStyle: {
                                    color: "#1E90FF",
                                    "font-size": "22px"
                                  }
                                },
                                [_vm._v("】")]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.departmentList === 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "achievements",
                                    staticStyle: {
                                      "flex-basis": "100%",
                                      "padding-left": "0",
                                      height: "40px"
                                    }
                                  },
                                  [
                                    _c("span", [_vm._v("部门业绩:")]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "assigned" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "padding-right": "10px",
                                                height: "28px",
                                                "line-height": "24px"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  staticClass: "item",
                                                  attrs: {
                                                    effect: "dark",
                                                    content: "点击去分配",
                                                    placement: "bottom",
                                                    disabled:
                                                      _vm.totalCount === 0
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "div-Posting",
                                                      on: {
                                                        click: _vm.isInputShow
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "f20 text-primary",
                                                          staticStyle: {
                                                            "font-size": "20px"
                                                          }
                                                        },
                                                        [_vm._v("【")]
                                                      ),
                                                      _c("span", [
                                                        _vm._v("待分配:")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("u", [
                                                        _vm._v(
                                                          _vm._s(_vm.totalCount)
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm._l(_vm.DepartmentalList, function(
                                            item
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: item,
                                                staticStyle: {
                                                  "padding-right": "5px"
                                                }
                                              },
                                              [
                                                item.departmentName !== ""
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-primary"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.departmentName
                                                              ) + ": "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("el-input", {
                                                          staticStyle: {
                                                            width: "100px"
                                                          },
                                                          attrs: {
                                                            size: "mini",
                                                            oninput:
                                                              _vm.onInputNumPoint
                                                          },
                                                          model: {
                                                            value:
                                                              item.achievement,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "achievement",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.achievement"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "f20 text-primary",
                                              staticStyle: {
                                                "font-size": "20px"
                                              }
                                            },
                                            [_vm._v("】")]
                                          )
                                        ],
                                        2
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "order-content",
                            staticStyle: { height: "40px" }
                          },
                          [
                            _vm._l(_vm.clearingForm, function(item) {
                              return _c(
                                "div",
                                {
                                  key: item.iconfont,
                                  staticClass: "order-content-item"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "typeOfPayment",
                                      on: {
                                        click: function($event) {
                                          return _vm.choiceOfPaymentMethod(item)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _c(
                                          "svg",
                                          {
                                            staticClass: "icon",
                                            attrs: { "aria-hidden": "true" }
                                          },
                                          [
                                            _c("use", {
                                              attrs: {
                                                href: "#" + item.iconfont
                                              }
                                            })
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(item.name))]),
                                      _vm._v(" "),
                                      item.paymentAmount > 0
                                        ? _c(
                                            "span",
                                            {
                                              class:
                                                item.name === "智慧支付" &&
                                                _vm.globalPaymentStatus === "1"
                                                  ? "money active"
                                                  : "money"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("amountType")(
                                                      item.paymentAmount
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm.isIndividualTraveler
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "order-content-item" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "typeOfPayment" },
                                        [
                                          _c("span", [
                                            _c(
                                              "svg",
                                              {
                                                staticClass: "icon",
                                                attrs: { "aria-hidden": "true" }
                                              },
                                              [
                                                _c("use", {
                                                  attrs: {
                                                    href: "#icon-huiyuanqia"
                                                  }
                                                })
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.isSubcard
                                            ? [
                                                _c("span", [
                                                  _vm._v("智慧耗卡")
                                                ]),
                                                _vm._v(" "),
                                                _vm.numberOfCardConsumptionNumber >
                                                0
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "money" },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.numberOfCardConsumptionNumber
                                                            ) +
                                                            "次 "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            : [
                                                _c("span", [
                                                  _vm._v("智慧耗卡")
                                                ]),
                                                _vm._v(" "),
                                                _vm.accuracyCheck(
                                                  _vm.amountOfConsumableCardNumber,
                                                  _vm.canConsumeCardIncreaseGold
                                                ) > 0
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "money" },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "amountType"
                                                              )(
                                                                _vm.accuracyCheck(
                                                                  _vm.amountOfConsumableCardNumber,
                                                                  _vm.canConsumeCardIncreaseGold
                                                                )
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "interval" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "order-content-item",
                                on: { click: _vm.adjustedPayment }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "typeOfPayment" },
                                  [
                                    _c("span", [
                                      _c(
                                        "svg",
                                        {
                                          staticClass: "icon",
                                          attrs: { "aria-hidden": "true" }
                                        },
                                        [
                                          _c("use", {
                                            attrs: { href: "#icon-hunhe" }
                                          })
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    [_c("span", [_vm._v("调整支付")])]
                                  ],
                                  2
                                )
                              ]
                            )
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content-order-list" },
                      _vm._l(_vm.orderData, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "content-order-item" },
                          [
                            _c("div", { staticClass: "order-info" }, [
                              _c("div", { staticClass: "order-title" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(item.packageName || item.productName)
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "order-type" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      item.packageTypeName ||
                                        item.productTypeName
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm._f("amountType")(item.total))
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _vm._l(item.employeeList, function(
                              subItem,
                              employeeIndex
                            ) {
                              return _c(
                                "div",
                                { key: employeeIndex, staticClass: "staff" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "jobType" },
                                    [
                                      _vm.analyticalDataCommodity(item) === "0"
                                        ? [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(subItem.workType[0])
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(subItem.workType[1])
                                              )
                                            ])
                                          ]
                                        : [
                                            _c("i", [_vm._v("销售")]),
                                            _vm._v(" "),
                                            _c("i", [
                                              _vm._v(_vm._s(employeeIndex + 1))
                                            ])
                                          ]
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "employeePerformanceText" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "employeeName" },
                                        [_vm._v(_vm._s(subItem.employeeNo))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "appoint",
                                          style: {
                                            color:
                                              subItem.appoint === 0
                                                ? "#333333"
                                                : "#f64e60"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "modifyADesignation",
                                                {
                                                  projectItem: item,
                                                  employeeItem: subItem
                                                }
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                subItem.appoint === 0
                                                  ? "非指定"
                                                  : "指定"
                                              ) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "labour" }, [
                                        _vm._v("劳动")
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "market" }, [
                                        _vm._v("销售")
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "employeePerformance" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "employeeName" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(subItem.employeeName) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "appoint" }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "labour" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: subItem.work,
                                              expression: "subItem.work"
                                            }
                                          ],
                                          attrs: {
                                            type: "text",
                                            disabled: _vm.calculateWhetherPerformanceIsModifiable(
                                              "work",
                                              subItem,
                                              item
                                            ),
                                            onfocus: "this.select()"
                                          },
                                          domProps: { value: subItem.work },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                subItem,
                                                "work",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        !_vm.calculateWhetherPerformanceIsModifiable(
                                          "work",
                                          subItem,
                                          item
                                        )
                                          ? _c("span", {
                                              staticClass:
                                                "iconfont icon-bianji1"
                                            })
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "market" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: subItem.sell,
                                              expression: "subItem.sell"
                                            }
                                          ],
                                          attrs: {
                                            type: "text",
                                            disabled: _vm.calculateWhetherPerformanceIsModifiable(
                                              "sell",
                                              subItem,
                                              item
                                            ),
                                            onfocus: "this.select()"
                                          },
                                          domProps: { value: subItem.sell },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                subItem,
                                                "sell",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        !_vm.calculateWhetherPerformanceIsModifiable(
                                          "sell",
                                          subItem,
                                          item
                                        )
                                          ? _c("span", {
                                              staticClass:
                                                "iconfont icon-bianji1"
                                            })
                                          : _vm._e()
                                      ])
                                    ]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "el-drawer",
                      {
                        attrs: {
                          "append-to-body": true,
                          size: "40%",
                          "show-close": false,
                          withHeader: false,
                          "before-close": _vm.innerDrawerHandleClose,
                          visible: _vm.innerDrawer
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.innerDrawer = $event
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "mixedPayment" },
                          [
                            _c("div", { staticClass: "mixedPayment-title" }, [
                              _c("span", [
                                _vm._v("支付详情，共需支付："),
                                _c("i", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("amountType")(
                                        _vm.amountInTotal -
                                          _vm.settlementAllowance
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "iconfont icon-guanbi",
                                on: { click: _vm.innerDrawerHandleClose }
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "modeOfPaymentList" },
                              [
                                _vm._l(_vm.modifyPaymentAmount, function(item) {
                                  return !(
                                    _vm.type === 3 &&
                                    (item.name === "耗卡本金" ||
                                      item.name === "耗卡赠金")
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          key: item.name,
                                          staticClass: "modeOfPaymentList-item"
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "white-space": "nowrap"
                                              }
                                            },
                                            [_vm._v(_vm._s(item.name) + ":")]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.money,
                                                expression: "item.money"
                                              }
                                            ],
                                            attrs: {
                                              type: "text",
                                              oninput:
                                                "value=value.replace(/[^0-9.]/g,'')"
                                            },
                                            domProps: { value: item.money },
                                            on: {
                                              blur:
                                                _vm.calculateWhetherTheAmountExceeded,
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  item,
                                                  "money",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          item.name === "智慧支付"
                                            ? [
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: _vm.smartPayment
                                                    }
                                                  },
                                                  [_vm._v("支付")]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                }),
                                _vm._v(" "),
                                _vm.isIndividualTraveler
                                  ? [
                                      _vm.isSubcard
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "modeOfPaymentList-item"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("智慧耗卡:")
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.numberOfCardConsumptionNumber,
                                                      expression:
                                                        "numberOfCardConsumptionNumber"
                                                    }
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    disabled: true
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.numberOfCardConsumptionNumber
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.numberOfCardConsumptionNumber =
                                                        $event.target.value
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        : [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "modeOfPaymentList-item"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("智慧耗卡（本金）:")
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.amountOfConsumableCardNumber,
                                                      expression:
                                                        "amountOfConsumableCardNumber"
                                                    }
                                                  ],
                                                  class: !_vm
                                                    .calculateThePrincipalIncreaseModification[0]
                                                    ? "active"
                                                    : "",
                                                  attrs: {
                                                    type: "text",
                                                    disabled: !_vm
                                                      .calculateThePrincipalIncreaseModification[0]
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.amountOfConsumableCardNumber
                                                  },
                                                  on: {
                                                    blur: function($event) {
                                                      return _vm.modifyTheAmountOfTheRechargeCard(
                                                        "amountOfConsumableCardNumber"
                                                      )
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.amountOfConsumableCardNumber =
                                                        $event.target.value
                                                    }
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "modeOfPaymentList-item"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("智慧耗卡（赠金）:")
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.canConsumeCardIncreaseGold,
                                                      expression:
                                                        "canConsumeCardIncreaseGold"
                                                    }
                                                  ],
                                                  class: !_vm
                                                    .calculateThePrincipalIncreaseModification[1]
                                                    ? "active"
                                                    : "clearBac",
                                                  attrs: {
                                                    type: "text",
                                                    disabled: !_vm
                                                      .calculateThePrincipalIncreaseModification[1]
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.canConsumeCardIncreaseGold
                                                  },
                                                  on: {
                                                    blur: function($event) {
                                                      return _vm.modifyTheAmountOfTheRechargeCard(
                                                        "canConsumeCardIncreaseGold"
                                                      )
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.canConsumeCardIncreaseGold =
                                                        $event.target.value
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "el-drawer",
                              {
                                attrs: {
                                  "append-to-body": true,
                                  size: "40%",
                                  "show-close": true,
                                  withHeader: false,
                                  "before-close":
                                    _vm.closeTheScanCodePaymentWindow,
                                  visible: _vm.intelligentPaymentState
                                },
                                on: {
                                  "update:visible": function($event) {
                                    _vm.intelligentPaymentState = $event
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "smartPayment" }, [
                                  _c(
                                    "div",
                                    { staticClass: "wisdomPaysTitle" },
                                    [
                                      _c("span", [_vm._v("您当前正在通过")]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "paymentMethodDetails" },
                                        [
                                          _c("span", [
                                            _c(
                                              "svg",
                                              {
                                                staticClass: "icon",
                                                attrs: { "aria-hidden": "true" }
                                              },
                                              [
                                                _c("use", {
                                                  attrs: {
                                                    href: "#icon-shoukuan"
                                                  }
                                                })
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("智慧支付")]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !_vm.innerDrawer,
                                                  expression: "!innerDrawer"
                                                }
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("amountType")(
                                                    _vm.clearingForm.reduce(
                                                      function(pv, cu) {
                                                        if (
                                                          cu.name === "智慧支付"
                                                        ) {
                                                          return _vm.accuracyCheck(
                                                            pv,
                                                            cu.paymentAmount
                                                          )
                                                        } else {
                                                          return pv
                                                        }
                                                      },
                                                      0
                                                    )
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.innerDrawer,
                                                  expression: "innerDrawer"
                                                }
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("amountType")(
                                                    _vm.modifyPaymentAmount.reduce(
                                                      function(pv, cu) {
                                                        if (
                                                          cu.name === "智慧支付"
                                                        ) {
                                                          return _vm.accuracyCheck(
                                                            pv,
                                                            cu.money
                                                          )
                                                        } else {
                                                          return pv
                                                        }
                                                      },
                                                      0
                                                    )
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "paymentModeSwitching" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class:
                                            _vm.smartPaymentMethod === "0"
                                              ? "active"
                                              : "",
                                          on: {
                                            click: function($event) {
                                              return _vm.switchingPaymentMethods(
                                                "0"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("商家扫码收款")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          class:
                                            _vm.smartPaymentMethod === "1"
                                              ? "active"
                                              : "",
                                          on: {
                                            click: function($event) {
                                              return _vm.switchingPaymentMethods(
                                                "1"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("顾客扫码收款")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "collectionContents" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "merchantScanningCode",
                                          style:
                                            _vm.smartPaymentMethod === "0"
                                              ? {
                                                  height: "auto",
                                                  opacity: 1,
                                                  position: "relative",
                                                  "z-index": 999
                                                }
                                              : {
                                                  height: 0,
                                                  opacity: 0,
                                                  position: "relative",
                                                  "z-index": 1
                                                }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "paymentContent" },
                                            [
                                              _c("input", {
                                                ref: "scanToPay",
                                                attrs: {
                                                  type: "text",
                                                  placeholder:
                                                    "请使用扫码枪扫码输入",
                                                  oninput:
                                                    "value=value.replace(/[^0-9.]/g,'')"
                                                },
                                                domProps: {
                                                  value: _vm.codeNumber
                                                },
                                                on: {
                                                  keydown: _vm.scanCodeGunInput
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", [_vm._v("支付")])
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "customerScanCode",
                                          style:
                                            _vm.smartPaymentMethod === "1"
                                              ? {
                                                  height: "auto",
                                                  opacity: 1,
                                                  position: "relative",
                                                  "z-index": 999
                                                }
                                              : {
                                                  height: 0,
                                                  opacity: 0,
                                                  position: "relative",
                                                  "z-index": 1
                                                }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "paymentContent" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "payBox" },
                                                [
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src:
                                                          _vm.paymentCardPaymentAddress,
                                                        alt: "暂无开通拉卡拉"
                                                      }
                                                    })
                                                  ],
                                                  _vm._v(" "),
                                                  _vm.payState === 100
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "payImg"
                                                          },
                                                          [
                                                            _c("span", {
                                                              staticClass:
                                                                "iconfont icon-zhifuchenggong"
                                                            }),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v("支付中")
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    : _vm.payState === 300
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "payImg"
                                                          },
                                                          [
                                                            _c("span", {
                                                              staticClass:
                                                                "iconfont icon-qunfengzhifuchenggong"
                                                            }),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v("支成功")
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "payInfo" },
                                                [
                                                  _c("span", [
                                                    _vm._v("扫码支付")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      "请顾客使用微信或支付宝扫此二维码"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-drawer",
                      {
                        attrs: {
                          "append-to-body": true,
                          size: "40%",
                          "show-close": true,
                          withHeader: false,
                          "before-close": _vm.closeTheScanCodePaymentWindow,
                          visible: _vm.intelligentPaymentState
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.intelligentPaymentState = $event
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "smartPayment" }, [
                          _c("div", { staticClass: "wisdomPaysTitle" }, [
                            _c("span", [_vm._v("您当前正在通过")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "paymentMethodDetails" },
                              [
                                _c("span", [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "icon",
                                      attrs: { "aria-hidden": "true" }
                                    },
                                    [
                                      _c("use", {
                                        attrs: { href: "#icon-shoukuan" }
                                      })
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v("智慧支付")]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.innerDrawer,
                                        expression: "!innerDrawer"
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("amountType")(
                                          _vm.clearingForm.reduce(function(
                                            pv,
                                            cu
                                          ) {
                                            if (cu.name === "智慧支付") {
                                              return _vm.accuracyCheck(
                                                pv,
                                                cu.paymentAmount
                                              )
                                            } else {
                                              return pv
                                            }
                                          },
                                          0)
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.innerDrawer,
                                        expression: "innerDrawer"
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("amountType")(
                                          _vm.modifyPaymentAmount.reduce(
                                            function(pv, cu) {
                                              if (cu.name === "智慧支付") {
                                                return _vm.accuracyCheck(
                                                  pv,
                                                  cu.money
                                                )
                                              } else {
                                                return pv
                                              }
                                            },
                                            0
                                          )
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "paymentModeSwitching" }, [
                            _c(
                              "span",
                              {
                                class:
                                  _vm.smartPaymentMethod === "0"
                                    ? "active"
                                    : "",
                                on: {
                                  click: function($event) {
                                    return _vm.switchingPaymentMethods("0")
                                  }
                                }
                              },
                              [_vm._v("商家扫码收款")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                class:
                                  _vm.smartPaymentMethod === "1"
                                    ? "active"
                                    : "",
                                on: {
                                  click: function($event) {
                                    return _vm.switchingPaymentMethods("1")
                                  }
                                }
                              },
                              [_vm._v("顾客扫码收款")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "collectionContents" }, [
                            _c(
                              "div",
                              {
                                staticClass: "merchantScanningCode",
                                style:
                                  _vm.smartPaymentMethod === "0"
                                    ? {
                                        height: "auto",
                                        opacity: 1,
                                        position: "relative",
                                        "z-index": 999
                                      }
                                    : {
                                        height: 0,
                                        opacity: 0,
                                        position: "relative",
                                        "z-index": 1
                                      }
                              },
                              [
                                _c("div", { staticClass: "paymentContent" }, [
                                  _c("input", {
                                    ref: "scanToPay",
                                    attrs: {
                                      type: "text",
                                      placeholder: "请使用扫码枪扫码输入",
                                      oninput:
                                        "value=value.replace(/[^0-9.]/g,'')"
                                    },
                                    domProps: { value: _vm.codeNumber },
                                    on: { keydown: _vm.scanCodeGunInput }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("支付")])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "customerScanCode",
                                style:
                                  _vm.smartPaymentMethod === "1"
                                    ? {
                                        height: "auto",
                                        opacity: 1,
                                        position: "relative",
                                        "z-index": 999
                                      }
                                    : {
                                        height: 0,
                                        opacity: 0,
                                        position: "relative",
                                        "z-index": 1
                                      }
                              },
                              [
                                _c("div", { staticClass: "paymentContent" }, [
                                  _c(
                                    "div",
                                    { staticClass: "payBox" },
                                    [
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.paymentCardPaymentAddress,
                                            alt: "暂无开通拉卡拉"
                                          }
                                        })
                                      ],
                                      _vm._v(" "),
                                      _vm.payState === 100
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "payImg" },
                                              [
                                                _c("span", {
                                                  staticClass:
                                                    "iconfont icon-zhifuchenggong"
                                                }),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("支付中")])
                                              ]
                                            )
                                          ]
                                        : _vm.payState === 300
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "payImg" },
                                              [
                                                _c("span", {
                                                  staticClass:
                                                    "iconfont icon-qunfengzhifuchenggong"
                                                }),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("支成功")])
                                              ]
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "payInfo" }, [
                                    _c("span", [_vm._v("扫码支付")]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v("请顾客使用微信或支付宝扫此二维码")
                                    ])
                                  ])
                                ])
                              ]
                            )
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.type === 4
            ? [
                _c("div", { staticClass: "openACard" }, [
                  _c("div", { staticClass: "close" }, [
                    _c("div", { staticClass: "singInfo" }, [
                      _c("span", [_vm._v("会员开卡")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.cardPurchase,
                              expression: "cardPurchase"
                            }
                          ],
                          staticClass: "mies",
                          on: {
                            click: function($event) {
                              _vm.isMies = !_vm.isMies
                            }
                          }
                        },
                        [
                          _c("span", { class: _vm.isMies ? "active" : "" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("发送消费信息")])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "orderTrackingNumber",
                          staticStyle: { position: "relative" }
                        },
                        [
                          _c("span", [_vm._v("流水单号：")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "border_color",
                                rawName: "v-border_color"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.billNumber,
                                expression: "billNumber"
                              }
                            ],
                            attrs: {
                              type: "text",
                              placeholder: "请输入流水单号",
                              oninput: "value=value.replace(/[^0-9.]/g,'')"
                            },
                            domProps: { value: _vm.billNumber },
                            on: {
                              keyup: _vm.OnBillNumber,
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.billNumber = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.RunningOrdersShow,
                                  expression: "RunningOrdersShow"
                                }
                              ],
                              class: {
                                repatInput: _vm.RunningOrdersShow == true,
                                isShowx:
                                  _vm.RunningOrdersText != "该流水单号已录入"
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.RunningOrdersText) +
                                  "\n                "
                              ),
                              _c("div", {
                                class: {
                                  repatInputafter: _vm.RunningOrdersShow,
                                  isShowx:
                                    _vm.RunningOrdersText != "该流水单号已录入"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "operationcard" },
                      [
                        _vm.cardPurchase
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "opencard",
                                  on: { click: _vm.handleBack }
                                },
                                [_c("span", [_vm._v("返回")])]
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        [
                          !_vm.cardPurchase
                            ? _c(
                                "div",
                                {
                                  class:
                                    _vm.cardPurchase &&
                                    _vm.individualCardPaymentStatus
                                      ? "opencard active"
                                      : "opencard",
                                  on: {
                                    click: function($event) {
                                      return _vm.openSexCard()
                                    }
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass: "iconfont icon-jiesuan"
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("开卡")])
                                ]
                              )
                            : _vm._e()
                        ],
                        _vm._v(" "),
                        _vm.cardPurchase
                          ? [
                              _c(
                                "div",
                                {
                                  class:
                                    _vm.cardPurchase &&
                                    _vm.individualCardPaymentStatus
                                      ? "opencard active"
                                      : "opencard",
                                  on: {
                                    click: function($event) {
                                      return _vm.openSexCard()
                                    }
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass: "iconfont icon-jiesuan"
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("结算")])
                                ]
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { on: { click: _vm.handleClose } }, [
                          _c("span", { staticClass: "iconfont icon-guanbi" })
                        ])
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "openACardBody" },
                    [
                      _c("div", { staticClass: "openACardBody-left" }, [
                        _c("div", { staticClass: "userInfo" }, [
                          _c(
                            "div",
                            {
                              staticClass: "phone",
                              staticStyle: { position: "relative" }
                            },
                            [
                              _c("span", [_vm._v("手机号")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.editMemberInformationContent
                                        .memberMobile,
                                    expression:
                                      "editMemberInformationContent.memberMobile"
                                  }
                                ],
                                ref: "memberMobileRef",
                                attrs: {
                                  type: "text",
                                  disabled: !_vm.memberEditor,
                                  maxlength: "11",
                                  "data-type": "memberMobile"
                                },
                                domProps: {
                                  value:
                                    _vm.editMemberInformationContent
                                      .memberMobile
                                },
                                on: {
                                  keyup: _vm.updateMemberInformation,
                                  blur: _vm.focussing,
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.editMemberInformationContent,
                                      "memberMobile",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "i",
                                {
                                  staticStyle: {
                                    position: "absolute",
                                    right: "25px",
                                    top: "55%",
                                    transform: "translateY(-50%)",
                                    "font-size": "20px",
                                    color: "red"
                                  }
                                },
                                [_vm._v("*")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "name",
                              staticStyle: { position: "relative" }
                            },
                            [
                              _c("span", [_vm._v("姓名")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.editMemberInformationContent
                                        .memberName,
                                    expression:
                                      "editMemberInformationContent.memberName"
                                  }
                                ],
                                ref: "memberNameRef",
                                attrs: {
                                  type: "text",
                                  maxlength: "18",
                                  "data-type": "memberName",
                                  disabled: !_vm.memberEditor
                                },
                                domProps: {
                                  value:
                                    _vm.editMemberInformationContent.memberName
                                },
                                on: {
                                  keyup: _vm.updateMemberInformation,
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.editMemberInformationContent,
                                      "memberName",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "i",
                                {
                                  staticStyle: {
                                    position: "absolute",
                                    right: "25px",
                                    top: "55%",
                                    transform: "translateY(-50%)",
                                    "font-size": "20px",
                                    color: "red"
                                  }
                                },
                                [_vm._v("*")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "membership_number" }, [
                            _c("span", [_vm._v("会员编号")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.editMemberInformationContent.memberNo,
                                  expression:
                                    "editMemberInformationContent.memberNo"
                                }
                              ],
                              attrs: {
                                type: "text",
                                disabled: !_vm.memberEditor,
                                "data-type": "memberNo"
                              },
                              domProps: {
                                value: _vm.editMemberInformationContent.memberNo
                              },
                              on: {
                                keyup: _vm.updateMemberInformation,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.editMemberInformationContent,
                                    "memberNo",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "wechat_id" }, [
                            _c("span", [_vm._v("微信")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.editMemberInformationContent
                                      .wechatAccount,
                                  expression:
                                    "editMemberInformationContent.wechatAccount"
                                }
                              ],
                              attrs: {
                                type: "text",
                                disabled: !_vm.memberEditor,
                                "data-type": "wechatAccount"
                              },
                              domProps: {
                                value:
                                  _vm.editMemberInformationContent.wechatAccount
                              },
                              on: {
                                keyup: _vm.updateMemberInformation,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.editMemberInformationContent,
                                    "wechatAccount",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "gender" }, [
                            _c("span", [_vm._v("性别")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "sexSelection" }, [
                              _c(
                                "div",
                                {
                                  class:
                                    _vm.editMemberInformationContent.gender ===
                                    1
                                      ? "sexSelection-item active"
                                      : "sexSelection-item",
                                  attrs: {
                                    "data-type": "gender",
                                    "data-value": "1"
                                  },
                                  on: { click: _vm.updateMemberInformation }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: {
                                        "data-type": "gender",
                                        "data-value": "1"
                                      }
                                    },
                                    [_vm._v("男")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class:
                                    _vm.editMemberInformationContent.gender ===
                                    0
                                      ? "sexSelection-item active"
                                      : "sexSelection-item",
                                  attrs: {
                                    "data-type": "gender",
                                    "data-value": "0"
                                  },
                                  on: { click: _vm.updateMemberInformation }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: {
                                        "data-type": "gender",
                                        "data-value": "0"
                                      }
                                    },
                                    [_vm._v("女")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class:
                                    _vm.editMemberInformationContent.gender ===
                                    2
                                      ? "sexSelection-item active"
                                      : "sexSelection-item",
                                  attrs: {
                                    "data-type": "gender",
                                    "data-value": "2"
                                  },
                                  on: { click: _vm.updateMemberInformation }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: {
                                        "data-type": "gender",
                                        "data-value": "2"
                                      }
                                    },
                                    [_vm._v("保密")]
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "birthday" }, [
                            _c("span", [_vm._v("生日")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "birthdayChoice" },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "date",
                                    disabled: !_vm.memberEditor,
                                    "value-format": "yyyy-MM-dd",
                                    format: "yyyy-MM-dd",
                                    size: "mini",
                                    editable: false,
                                    "data-type": "birthday",
                                    placeholder: "选择日期"
                                  },
                                  model: {
                                    value:
                                      _vm.editMemberInformationContent.birthday,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.editMemberInformationContent,
                                        "birthday",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "editMemberInformationContent.birthday"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "member_class" }, [
                            _c("span", [_vm._v("等级")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "class_select" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled: !_vm.memberEditor,
                                      placeholder: "请选择",
                                      size: "mini"
                                    },
                                    model: {
                                      value:
                                        _vm.editMemberInformationContent
                                          .memberLevelName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editMemberInformationContent,
                                          "memberLevelName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "editMemberInformationContent.memberLevelName"
                                    }
                                  },
                                  _vm._l(
                                    _vm.membershipData.memberClass,
                                    function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "matching" }, [
                            _c("span", [_vm._v("是否匹配")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "enableMatching" }, [
                              _c(
                                "div",
                                {
                                  class:
                                    _vm.editMemberInformationContent
                                      .deductionsState === 1
                                      ? "enableMatching-item active"
                                      : "enableMatching-item",
                                  attrs: {
                                    "data-type": "deductionsState",
                                    "data-value": "1"
                                  },
                                  on: { click: _vm.updateMemberInformation }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: {
                                        "data-type": "deductionsState",
                                        "data-value": "1"
                                      }
                                    },
                                    [_vm._v("开启")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class:
                                    _vm.editMemberInformationContent
                                      .deductionsState === null ||
                                    _vm.editMemberInformationContent
                                      .deductionsState === 0
                                      ? "enableMatching-item active"
                                      : "enableMatching-item",
                                  attrs: {
                                    "data-type": "deductionsState",
                                    "data-value": "0"
                                  },
                                  on: { click: _vm.updateMemberInformation }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: {
                                        "data-type": "deductionsState",
                                        "data-value": "0"
                                      }
                                    },
                                    [_vm._v("关闭")]
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "source" }, [
                            _c("span", [_vm._v("顾客来源")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "source_content" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "请选择",
                                      size: "mini"
                                    },
                                    model: {
                                      value:
                                        _vm.editMemberInformationContent
                                          .memberSourceName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editMemberInformationContent,
                                          "memberSourceName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "editMemberInformationContent.memberSourceName"
                                    }
                                  },
                                  _vm._l(_vm.membershipData.source, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "remark" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.editMemberInformationContent.remark,
                                  expression:
                                    "editMemberInformationContent.remark"
                                }
                              ],
                              attrs: {
                                rows: "4",
                                cols: "25",
                                placeholder: "会员备注",
                                "data-type": "remark"
                              },
                              domProps: {
                                value: _vm.editMemberInformationContent.remark
                              },
                              on: {
                                blur: _vm.updateMemberInformation,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.editMemberInformationContent,
                                    "remark",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "newAddMemberInfo" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: _vm.isNewMemberInfo
                                      ? "primary"
                                      : "info",
                                    disabled: !_vm.isNewMemberInfo
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.enableMemberInformationEditing.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "iconfont icon-tianjia",
                                    staticStyle: { "margin-right": "5px" }
                                  }),
                                  _vm._v("创建新会员")
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      !_vm.cardPurchase
                        ? [
                            _c("div", { staticClass: "openACardBody-right" }, [
                              _c(
                                "div",
                                { staticClass: "optionalBar" },
                                [
                                  _c(
                                    "el-tabs",
                                    {
                                      attrs: { type: "card" },
                                      on: {
                                        "tab-click": _vm.selectiveCardType
                                      },
                                      model: {
                                        value: _vm.activeName,
                                        callback: function($$v) {
                                          _vm.activeName = $$v
                                        },
                                        expression: "activeName"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-tab-pane",
                                        {
                                          attrs: {
                                            label: "开卡",
                                            name: "openACard"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "membershipCardOpening"
                                            },
                                            _vm._l(
                                              _vm.openTheCardItemList,
                                              function(item) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: item.cardTypeCode,
                                                    staticClass:
                                                      "membership_item"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "title_membership"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.cardTypeName
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "sunTzuCardItem"
                                                      },
                                                      _vm._l(
                                                        item.cardItemList,
                                                        function(subItem) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key: subItem.id,
                                                              staticClass:
                                                                "sunTzuCardItem_item",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.openMembershipCard(
                                                                    subItem
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  class:
                                                                    _vm.taggedMember.indexOf(
                                                                      subItem.cardNo
                                                                    ) !== -1
                                                                      ? "active"
                                                                      : ""
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      subItem.cardName
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  class:
                                                                    _vm.taggedMember.indexOf(
                                                                      subItem.cardNo
                                                                    ) !== -1
                                                                      ? "active"
                                                                      : ""
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      subItem.cardNo
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-tab-pane",
                                        {
                                          attrs: {
                                            label: "个性次卡",
                                            name: "personalitySubcard"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "personalitySubcard"
                                            },
                                            _vm._l(
                                              _vm.listOfSubCardItems,
                                              function(item) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: item.packageTypeId,
                                                    staticClass:
                                                      "personalitySubcard-item"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "title-content"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            class: item.cardActive
                                                              ? "active"
                                                              : "",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.subCardItemOption(
                                                                  item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.packageTypeName
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.getPackageAvailableLetters(
                                                          item
                                                        ).length >= 2
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "alphabeticScreening",
                                                                staticStyle: {
                                                                  "margin-left":
                                                                    "30px"
                                                                }
                                                              },
                                                              _vm._l(
                                                                _vm.getPackageAvailableLetters(
                                                                  item
                                                                ),
                                                                function(
                                                                  letter
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: letter,
                                                                      class: [
                                                                        "alphabeticScreening-item",
                                                                        item.currentLetter ===
                                                                        letter
                                                                          ? "active"
                                                                          : ""
                                                                      ],
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          return _vm.selectPackageLetter(
                                                                            item,
                                                                            letter
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          letter.toUpperCase()
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        item.cardActive
                                                          ? _c("i", {
                                                              staticClass:
                                                                "iconfont icon-shanchu2",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.deleteSubCardItems(
                                                                    item
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "contentBody"
                                                      },
                                                      _vm._l(
                                                        _vm.filteredPackageList(
                                                          item
                                                        ),
                                                        function(subItem) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key: subItem.id,
                                                              class: subItem.cardActive
                                                                ? "contentBody-item active"
                                                                : "contentBody-item",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.subCardItemOption(
                                                                    subItem
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    subItem.packageName
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    subItem.packageCode
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              subItem.cardActive
                                                                ? _c("span", {
                                                                    staticClass:
                                                                      "iconfont icon-shanchu2",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.deleteSubCardItems(
                                                                          subItem
                                                                        )
                                                                      }
                                                                    }
                                                                  })
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-dialog",
                                            {
                                              attrs: {
                                                title: "个性次卡",
                                                visible: _vm.modifyPopUp,
                                                width: "550px",
                                                "custom-class":
                                                  "addPersonalitySubCard",
                                                "append-to-body": true,
                                                "modal-append-to-body": true,
                                                "close-on-click-modal": false
                                              },
                                              on: {
                                                "update:visible": function(
                                                  $event
                                                ) {
                                                  _vm.modifyPopUp = $event
                                                },
                                                close:
                                                  _vm.closeTheSecondaryCardInformation
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "addPersonalSubCardInformation"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "subCardContent"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "project"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "http://meiqiling.oss-cn-shenzhen.aliyuncs.com/static/img/hair.102f112.jpeg",
                                                                alt: ""
                                                              }
                                                            })
                                                          ]),
                                                          _vm._v(" "),
                                                          _vm
                                                            .theSecondCardSelectsTheItem
                                                            .packageName
                                                            ? [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      (_vm
                                                                        .theSecondCardSelectsTheItem
                                                                        .packageName ||
                                                                        "") +
                                                                        "-" +
                                                                        (_vm
                                                                          .theSecondCardSelectsTheItem
                                                                          .packageCode ||
                                                                          "")
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            : [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .theSecondCardSelectsTheItem
                                                                        .packageTypeName ||
                                                                        ""
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                        ],
                                                        2
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        { staticClass: "time" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "time-content"
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v("次数：")
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("i", [
                                                                _c("b", [
                                                                  _vm._v("【")
                                                                ]),
                                                                _vm._v(
                                                                  "次数为 9999，表示无限次"
                                                                ),
                                                                _c("b", [
                                                                  _vm._v("】")
                                                                ])
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "quantityInputModule",
                                                                {
                                                                  attrs: {
                                                                    numberOfSubCards:
                                                                      _vm.numberOfSubCards,
                                                                    "min-number":
                                                                      "1"
                                                                  },
                                                                  on: {
                                                                    updateVisible: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.numberOfSubCards = $event
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "time-content"
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "时限（天）："
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("i", [
                                                                _c("b", [
                                                                  _vm._v("【")
                                                                ]),
                                                                _vm._v(
                                                                  "时限(天)为-1，表示无限期"
                                                                ),
                                                                _c("b", [
                                                                  _vm._v("】")
                                                                ])
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "quantityInputModule",
                                                                {
                                                                  attrs: {
                                                                    numberOfSubCards:
                                                                      _vm.subCardTimeLimit,
                                                                    "min-number":
                                                                      "-1"
                                                                  },
                                                                  on: {
                                                                    updateVisible: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.subCardTimeLimit = $event
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "closeBox" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          on: {
                                                            click:
                                                              _vm.closeTheSecondaryCardInformation
                                                          }
                                                        },
                                                        [_vm._v("取消")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          on: {
                                                            click:
                                                              _vm.confirmAdd
                                                          }
                                                        },
                                                        [_vm._v("确认添加")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          on: {
                                                            click: _vm.openACard
                                                          }
                                                        },
                                                        [_vm._v("去开卡")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.activeName === "openACard",
                                          expression:
                                            "activeName === 'openACard'"
                                        }
                                      ],
                                      staticClass: "hint"
                                    },
                                    [_vm._v("【红色，代表顾客已有此卡】")]
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        : [
                            _c(
                              "div",
                              { staticClass: "openACardBody-right" },
                              [
                                _vm.activeName === "personalitySubcard"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "Individual-sub-card-settlement"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "Sub-card-item" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "List-of-sub-card-items"
                                                },
                                                [
                                                  _c(
                                                    "el-table",
                                                    {
                                                      staticStyle: {
                                                        width: "100%"
                                                      },
                                                      attrs: {
                                                        data:
                                                          _vm.personalizedTimesCardPurchase,
                                                        size: "mini",
                                                        "max-height": "250"
                                                      }
                                                    },
                                                    [
                                                      _c("el-table-column", {
                                                        attrs: {
                                                          prop: "cardItemCode",
                                                          label: "编号/分类",
                                                          width: "180"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("el-table-column", {
                                                        attrs: {
                                                          prop: "cardItemName",
                                                          label: "名称"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("el-table-column", {
                                                        attrs: {
                                                          prop:
                                                            "numberOfSubCards",
                                                          label: "次数"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("el-table-column", {
                                                        attrs: {
                                                          prop:
                                                            "subCardTimeLimit",
                                                          label: "时限"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("el-table-column", {
                                                        attrs: {
                                                          fixed: "right",
                                                          label: "操作",
                                                          width: "120"
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var row =
                                                                  ref.row
                                                                var $index =
                                                                  ref.$index
                                                                return [
                                                                  _c(
                                                                    "el-button",
                                                                    {
                                                                      attrs: {
                                                                        type:
                                                                          "text",
                                                                        size:
                                                                          "small"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          return _vm.removeTheSubCardItem(
                                                                            $index
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "iconfont icon-shanchu1",
                                                                          staticStyle: {
                                                                            "font-size":
                                                                              "20px"
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "el-button",
                                                                    {
                                                                      attrs: {
                                                                        type:
                                                                          "text",
                                                                        size:
                                                                          "small"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          return _vm.modifyItem(
                                                                            row,
                                                                            $index
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "iconfont icon-bianji1",
                                                                          staticStyle: {
                                                                            "font-size":
                                                                              "20px"
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          false,
                                                          158053588
                                                        )
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "content-card" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "content-card-item"
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("总次数:")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _c("input", {
                                                      attrs: {
                                                        type: "text",
                                                        disabled: true
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.countTheTotalNumberOfIndividualCycles
                                                      }
                                                    })
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "content-card-item"
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("开卡价格:")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "border_color",
                                                          rawName:
                                                            "v-border_color"
                                                        },
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.memberCardPrice,
                                                          expression:
                                                            "memberCardPrice"
                                                        }
                                                      ],
                                                      attrs: {
                                                        type: "number",
                                                        onfocus: "this.select()"
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.memberCardPrice
                                                      },
                                                      on: {
                                                        input: [
                                                          function($event) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.memberCardPrice =
                                                              $event.target.value
                                                          },
                                                          _vm.onPriceChanged
                                                        ],
                                                        blur: _vm.onPriceChanged
                                                      }
                                                    })
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "content-card-item"
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("会员卡备注:")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.membershipCardRemarks,
                                                          expression:
                                                            "membershipCardRemarks"
                                                        }
                                                      ],
                                                      attrs: {
                                                        type: "text",
                                                        onfocus: "this.select()"
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.membershipCardRemarks
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.membershipCardRemarks =
                                                            $event.target.value
                                                        }
                                                      }
                                                    })
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "content-card-item"
                                                },
                                                [
                                                  _vm.existingRechargeCards &&
                                                  _vm.existingRechargeCards
                                                    .length &&
                                                  !_vm.isNewMemberInfo
                                                    ? _c(
                                                        "button",
                                                        {
                                                          class: _vm.isShow
                                                            ? "show"
                                                            : "",
                                                          on: {
                                                            click:
                                                              _vm.openCardShow
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "充值卡购买次卡"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.existingRechargeCards &&
                                          _vm.existingRechargeCards.length &&
                                          _vm.isShow &&
                                          !_vm.isNewMemberInfo
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "content-card-item",
                                                  staticStyle: {
                                                    display: "flex",
                                                    "flex-wrap": "wrap",
                                                    "align-items": "center",
                                                    gap: "6px",
                                                    padding: "4px 0",
                                                    width: "100%"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "13px",
                                                        color: "#666",
                                                        "font-weight": "bold",
                                                        "white-space": "nowrap"
                                                      }
                                                    },
                                                    [_vm._v("已有充值卡：")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.existingRechargeCards,
                                                    function(card) {
                                                      return _c(
                                                        "span",
                                                        {
                                                          key: card.id,
                                                          style: {
                                                            fontSize: "12px",
                                                            padding: "2px 10px",
                                                            borderRadius: "4px",
                                                            border: "1px solid",
                                                            cursor: "pointer",
                                                            transition:
                                                              "all 0.2s",
                                                            background:
                                                              _vm.selectedRechargeCard &&
                                                              _vm
                                                                .selectedRechargeCard
                                                                .id === card.id
                                                                ? "red"
                                                                : "#409EFF",
                                                            borderColor:
                                                              _vm.selectedRechargeCard &&
                                                              _vm
                                                                .selectedRechargeCard
                                                                .id === card.id
                                                                ? "#409EFF"
                                                                : "#d1e7ff",
                                                            color:
                                                              _vm.selectedRechargeCard &&
                                                              _vm
                                                                .selectedRechargeCard
                                                                .id === card.id
                                                                ? "#fff"
                                                                : "#fff"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.selectRechargeCard(
                                                                card
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                card.cardName
                                                              ) +
                                                              "（本金：" +
                                                              _vm._s(
                                                                card.initAmount
                                                              ) +
                                                              "，赠金：" +
                                                              _vm._s(
                                                                card.givenAmount
                                                              ) +
                                                              "）\n                      "
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "Sub-card-item-yuangong"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "List-of-sub-card-items"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "addOnSales",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.personalitySubCardAddedSales.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("span", {
                                                        staticClass:
                                                          "iconfont icon-a-xiaoshou2"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "18px",
                                                              "font-weight":
                                                                "bold"
                                                            }
                                                          },
                                                          [_vm._v("+")]
                                                        ),
                                                        _vm._v("开卡员工")
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "vessel" },
                                                    _vm._l(
                                                      _vm.personalitySubCardEmployeeList,
                                                      function(item, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticClass:
                                                              "market"
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.employeeName
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "market-info"
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v("销售")
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  [
                                                                    item.achievement
                                                                      ? [
                                                                          _c(
                                                                            "input",
                                                                            {
                                                                              directives: [
                                                                                {
                                                                                  name:
                                                                                    "model",
                                                                                  rawName:
                                                                                    "v-model",
                                                                                  value:
                                                                                    item.achievement,
                                                                                  expression:
                                                                                    "item.achievement"
                                                                                }
                                                                              ],
                                                                              attrs: {
                                                                                type:
                                                                                  "text",
                                                                                disabled:
                                                                                  _vm.whetherToDisablePerformanceModification ||
                                                                                  item.brokerageClass ===
                                                                                    "no",
                                                                                onfocus:
                                                                                  "this.select()"
                                                                              },
                                                                              domProps: {
                                                                                value:
                                                                                  item.achievement
                                                                              },
                                                                              on: {
                                                                                input: function(
                                                                                  $event
                                                                                ) {
                                                                                  if (
                                                                                    $event
                                                                                      .target
                                                                                      .composing
                                                                                  ) {
                                                                                    return
                                                                                  }
                                                                                  _vm.$set(
                                                                                    item,
                                                                                    "achievement",
                                                                                    $event
                                                                                      .target
                                                                                      .value
                                                                                  )
                                                                                }
                                                                              }
                                                                            }
                                                                          )
                                                                        ]
                                                                      : [
                                                                          _c(
                                                                            "input",
                                                                            {
                                                                              directives: [
                                                                                {
                                                                                  name:
                                                                                    "model",
                                                                                  rawName:
                                                                                    "v-model",
                                                                                  value:
                                                                                    item.percentage,
                                                                                  expression:
                                                                                    "item.percentage"
                                                                                }
                                                                              ],
                                                                              attrs: {
                                                                                type:
                                                                                  "text",
                                                                                disabled:
                                                                                  _vm.whetherToDisablePerformanceModification ||
                                                                                  item.brokerageClass ===
                                                                                    "no",
                                                                                onfocus:
                                                                                  "this.select()"
                                                                              },
                                                                              domProps: {
                                                                                value:
                                                                                  item.percentage
                                                                              },
                                                                              on: {
                                                                                input: function(
                                                                                  $event
                                                                                ) {
                                                                                  if (
                                                                                    $event
                                                                                      .target
                                                                                      .composing
                                                                                  ) {
                                                                                    return
                                                                                  }
                                                                                  _vm.$set(
                                                                                    item,
                                                                                    "percentage",
                                                                                    $event
                                                                                      .target
                                                                                      .value
                                                                                  )
                                                                                }
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                    _vm._v(" "),
                                                                    item.brokerageClass !==
                                                                    "no"
                                                                      ? _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "iconfont icon-bianji1"
                                                                          }
                                                                        )
                                                                      : _vm._e()
                                                                  ],
                                                                  2
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", {
                                                              staticClass:
                                                                "iconfont icon-closel",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.deletePersonalitySubCardEmployees(
                                                                    index
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "particulars" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "particulars-title"
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "iconfont icon-dingdan"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v("付款信息")
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "paymentAmountStatistics"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "title-content-item"
                                                    },
                                                    [
                                                      _c("span", {
                                                        staticClass:
                                                          "iconfont icon-yingfu"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("订单金额：")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "amountType"
                                                            )(
                                                              _vm.memberCardPrice
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticStyle: {
                                                        color: "#1E90FF",
                                                        "font-size": "22px"
                                                      }
                                                    },
                                                    [_vm._v("【")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "title-content-item"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v("付现：")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "amountType"
                                                            )(_vm.actualCashPay)
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "title-content-item"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v("可耗卡：")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "amountType"
                                                            )(_vm.haoCardMoney)
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "title-content-item",
                                                      staticStyle: {
                                                        display: "flex",
                                                        "align-items": "center",
                                                        margin: "0"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "margin-right":
                                                              "10px"
                                                          }
                                                        },
                                                        [_vm._v("优惠金额:")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            width: "80px",
                                                            height: "30px",
                                                            display: "flex"
                                                          }
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.memberCoupon,
                                                                expression:
                                                                  "memberCoupon"
                                                              }
                                                            ],
                                                            staticStyle: {
                                                              width: "100%",
                                                              height: "100%",
                                                              "border-radius":
                                                                "5px",
                                                              border:
                                                                "1px solid #E8E8E8",
                                                              "padding-left":
                                                                "10px",
                                                              "box-sizing":
                                                                "border-box"
                                                            },
                                                            attrs: {
                                                              type: "number",
                                                              onfocus:
                                                                "this.select()"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.memberCoupon
                                                            },
                                                            on: {
                                                              input: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.memberCoupon =
                                                                  $event.target.value
                                                              }
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticStyle: {
                                                        color: "#1E90FF",
                                                        "font-size": "22px"
                                                      }
                                                    },
                                                    [_vm._v("】")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.departmentList === 1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "achievements"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v("部门业绩:")
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("div", [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "assigned"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle: {
                                                                      "padding-right":
                                                                        "10px",
                                                                      height:
                                                                        "28px",
                                                                      "line-height":
                                                                        "24px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "f20 text-primary"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "【"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _vm._l(
                                                                  _vm.isDepartmentalPerformance,
                                                                  function(
                                                                    item
                                                                  ) {
                                                                    return _c(
                                                                      "div",
                                                                      {
                                                                        key:
                                                                          item.departmentId,
                                                                        staticStyle: {
                                                                          "padding-right":
                                                                            "5px"
                                                                        }
                                                                      },
                                                                      [
                                                                        item.departmentName !==
                                                                        ""
                                                                          ? _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "text-primary"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        item.departmentName
                                                                                      ) +
                                                                                        ": "
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "el-input",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      width:
                                                                                        "50px"
                                                                                    },
                                                                                    attrs: {
                                                                                      size:
                                                                                        "mini",
                                                                                      oninput:
                                                                                        _vm.onInputNumPoint
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        item.achievement,
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          item,
                                                                                          "achievement",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                      expression:
                                                                                        "item.achievement"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          : _vm._e()
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "f20 text-primary"
                                                                  },
                                                                  [_vm._v("】")]
                                                                )
                                                              ],
                                                              2
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "order-content"
                                                },
                                                [
                                                  _vm._l(
                                                    _vm.clearingForm,
                                                    function(item) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: item.iconfont,
                                                          staticClass:
                                                            "order-content-item",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.topUpPaymentAmount(
                                                                item,
                                                                "openCard"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "typeOfPayment"
                                                            },
                                                            [
                                                              _c("span", [
                                                                _c(
                                                                  "svg",
                                                                  {
                                                                    staticClass:
                                                                      "icon",
                                                                    attrs: {
                                                                      "aria-hidden":
                                                                        "true"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("use", {
                                                                      attrs: {
                                                                        href:
                                                                          "#" +
                                                                          item.iconfont
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.name
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              item.paymentAmount >
                                                              0
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      class:
                                                                        item.name ===
                                                                          "智慧支付" &&
                                                                        _vm.globalPaymentStatus ===
                                                                          "1"
                                                                          ? "money active"
                                                                          : "money"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "amountType"
                                                                          )(
                                                                            item.paymentAmount
                                                                          )
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.amountOfConsumableCardNumber >
                                                    0 ||
                                                  _vm.canConsumeCardIncreaseGold >
                                                    0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "order-content-item"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "typeOfPayment"
                                                            },
                                                            [
                                                              _c("span", [
                                                                _c(
                                                                  "svg",
                                                                  {
                                                                    staticClass:
                                                                      "icon",
                                                                    attrs: {
                                                                      "aria-hidden":
                                                                        "true"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("use", {
                                                                      attrs: {
                                                                        href:
                                                                          "#icon-huiyuanqia"
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v(
                                                                  "智慧耗卡"
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "money"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "amountType"
                                                                        )(
                                                                          _vm.accuracyCheck(
                                                                            _vm.amountOfConsumableCardNumber,
                                                                            _vm.canConsumeCardIncreaseGold
                                                                          )
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass: "interval"
                                                  })
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "adjustedPayment"
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass: "cutOffRule"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "order-content-item",
                                                      on: {
                                                        click:
                                                          _vm.adjustedPayment
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "typeOfPayment"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _c(
                                                              "svg",
                                                              {
                                                                staticClass:
                                                                  "icon",
                                                                attrs: {
                                                                  "aria-hidden":
                                                                    "true"
                                                                }
                                                              },
                                                              [
                                                                _c("use", {
                                                                  attrs: {
                                                                    href:
                                                                      "#icon-hunhe"
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("调整支付")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-dialog",
                                            {
                                              attrs: {
                                                title: "个性次卡",
                                                visible: _vm.modifyPopUp,
                                                "close-on-click-modal": false,
                                                width: "550px",
                                                "custom-class":
                                                  "addPersonalitySubCard",
                                                "append-to-body": true,
                                                "modal-append-to-body": true
                                              },
                                              on: {
                                                "update:visible": function(
                                                  $event
                                                ) {
                                                  _vm.modifyPopUp = $event
                                                },
                                                close:
                                                  _vm.closeTheSecondaryCardInformation
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "addPersonalSubCardInformation"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "subCardContent"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "project"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "http://meiqiling.oss-cn-shenzhen.aliyuncs.com/static/img/hair.102f112.jpeg",
                                                                alt: ""
                                                              }
                                                            })
                                                          ]),
                                                          _vm._v(" "),
                                                          _vm
                                                            .theSecondCardSelectsTheItem
                                                            .packageName
                                                            ? [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      (_vm
                                                                        .theSecondCardSelectsTheItem
                                                                        .packageName ||
                                                                        "") +
                                                                        "-" +
                                                                        (_vm
                                                                          .theSecondCardSelectsTheItem
                                                                          .packageCode ||
                                                                          "")
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            : [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .theSecondCardSelectsTheItem
                                                                        .packageTypeName ||
                                                                        ""
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                        ],
                                                        2
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        { staticClass: "time" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "time-content"
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v("次数：")
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("i", [
                                                                _c("b", [
                                                                  _vm._v("【")
                                                                ]),
                                                                _vm._v(
                                                                  "次数为 9999，表示无限次"
                                                                ),
                                                                _c("b", [
                                                                  _vm._v("】")
                                                                ])
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "quantityInputModule",
                                                                {
                                                                  attrs: {
                                                                    numberOfSubCards:
                                                                      _vm.numberOfSubCards,
                                                                    "min-number":
                                                                      "1"
                                                                  },
                                                                  on: {
                                                                    updateVisible: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.numberOfSubCards = $event
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "time-content"
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "时限（天）："
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("i", [
                                                                _c("b", [
                                                                  _vm._v("【")
                                                                ]),
                                                                _vm._v(
                                                                  "时限(天)为-1，表示无限期"
                                                                ),
                                                                _c("b", [
                                                                  _vm._v("】")
                                                                ])
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "quantityInputModule",
                                                                {
                                                                  attrs: {
                                                                    numberOfSubCards:
                                                                      _vm.subCardTimeLimit,
                                                                    "min-number":
                                                                      "-1"
                                                                  },
                                                                  on: {
                                                                    updateVisible: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.subCardTimeLimit = $event
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "closeBox" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          on: {
                                                            click:
                                                              _vm.closeTheSecondaryCardInformation
                                                          }
                                                        },
                                                        [_vm._v("取消")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          on: {
                                                            click:
                                                              _vm.confirmTheModificationOfSubCardItems
                                                          }
                                                        },
                                                        [_vm._v("确认修改")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.activeName === "openACard"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "membershipCardPurchase"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "Sub-card-item" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "List-of-sub-card-items"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm._f(
                                                        "filterCardPic"
                                                      )(
                                                        _vm
                                                          .selectMembershipCardItems
                                                          .cardTypeCode,
                                                        "bg"
                                                      ),
                                                      alt: ""
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _c("i", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm
                                                            .selectMembershipCardItems
                                                            .cardName
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("i", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm
                                                            .selectMembershipCardItems
                                                            .cardNo
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .selectMembershipCardItems
                                                          .cardTypeName
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "content-card" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "content-card-item"
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("开卡价格:")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "border_color",
                                                          rawName:
                                                            "v-border_color"
                                                        },
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.memberCardPrice,
                                                          expression:
                                                            "memberCardPrice"
                                                        }
                                                      ],
                                                      attrs: {
                                                        disabled: !_vm.openTheCardToModifyTheOriginalPrice,
                                                        type: "number",
                                                        onfocus: "this.select()"
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.memberCardPrice
                                                      },
                                                      on: {
                                                        input: [
                                                          function($event) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.memberCardPrice =
                                                              $event.target.value
                                                          },
                                                          _vm.onPriceChanged
                                                        ],
                                                        blur: _vm.onPriceChanged
                                                      }
                                                    })
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm
                                                          .selectMembershipCardItems
                                                          .cardTypeName ===
                                                        "充值卡",
                                                      expression:
                                                        "selectMembershipCardItems.cardTypeName === '充值卡'"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "content-card-item"
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("赠送金额:")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.amountOfGift,
                                                          expression:
                                                            "amountOfGift"
                                                        }
                                                      ],
                                                      attrs: {
                                                        type: "number",
                                                        disabled: !_vm.amountGiftCanBemodifiedByopeningCard,
                                                        onfocus: "this.select()"
                                                      },
                                                      domProps: {
                                                        value: _vm.amountOfGift
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.amountOfGift =
                                                            $event.target.value
                                                        }
                                                      }
                                                    })
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "content-card-item"
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("会员卡备注:")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.membershipCardRemarks,
                                                          expression:
                                                            "membershipCardRemarks"
                                                        }
                                                      ],
                                                      attrs: {
                                                        type: "text",
                                                        onfocus: "this.select()"
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.membershipCardRemarks
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.membershipCardRemarks =
                                                            $event.target.value
                                                        }
                                                      }
                                                    })
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "content-card-item"
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.existingRechargeCards &&
                                                            _vm
                                                              .existingRechargeCards
                                                              .length &&
                                                            _vm
                                                              .selectMembershipCardItems
                                                              .cardTypeCode ==
                                                              0 &&
                                                            !_vm.isNewMemberInfo,
                                                          expression:
                                                            "existingRechargeCards && existingRechargeCards.length&&selectMembershipCardItems.cardTypeCode==0&&!isNewMemberInfo"
                                                        }
                                                      ],
                                                      class: _vm.isShow
                                                        ? "show"
                                                        : "",
                                                      on: {
                                                        click: _vm.openCardShow
                                                      }
                                                    },
                                                    [_vm._v("充值卡购买次卡")]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.existingRechargeCards &&
                                          _vm.existingRechargeCards.length &&
                                          _vm.selectMembershipCardItems
                                            .cardTypeCode == 0 &&
                                          _vm.isShow &&
                                          !_vm.isNewMemberInfo
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "content-card-item",
                                                  staticStyle: {
                                                    display: "flex",
                                                    "flex-wrap": "wrap",
                                                    "align-items": "center",
                                                    gap: "6px",
                                                    padding: "4px 0",
                                                    width: "100%"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "13px",
                                                        color: "#666",
                                                        "font-weight": "bold",
                                                        "white-space": "nowrap"
                                                      }
                                                    },
                                                    [_vm._v("可选充值卡：")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.existingRechargeCards,
                                                    function(card) {
                                                      return _c(
                                                        "span",
                                                        {
                                                          key: card.id,
                                                          style: {
                                                            fontSize: "12px",
                                                            padding: "2px 10px",
                                                            borderRadius: "4px",
                                                            border: "1px solid",
                                                            cursor: "pointer",
                                                            transition:
                                                              "all 0.2s",
                                                            background:
                                                              _vm.selectedRechargeCard &&
                                                              _vm
                                                                .selectedRechargeCard
                                                                .id === card.id
                                                                ? "red"
                                                                : "#409EFF",
                                                            borderColor:
                                                              _vm.selectedRechargeCard &&
                                                              _vm
                                                                .selectedRechargeCard
                                                                .id === card.id
                                                                ? "#409EFF"
                                                                : "#d1e7ff",
                                                            color:
                                                              _vm.selectedRechargeCard &&
                                                              _vm
                                                                .selectedRechargeCard
                                                                .id === card.id
                                                                ? "#fff"
                                                                : "#fff"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.selectRechargeCard(
                                                                card
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                card.cardName
                                                              ) +
                                                              "（本金：" +
                                                              _vm._s(
                                                                card.initAmount
                                                              ) +
                                                              "，赠金：" +
                                                              _vm._s(
                                                                card.givenAmount
                                                              ) +
                                                              "）\n                      "
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "Sub-card-item-yuangong"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "List-of-sub-card-items"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "addOnSales",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.personalitySubCardAddedSales.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("span", {
                                                        staticClass:
                                                          "iconfont icon-a-xiaoshou2"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "18px",
                                                              "font-weight":
                                                                "bold"
                                                            }
                                                          },
                                                          [_vm._v("+")]
                                                        ),
                                                        _vm._v("开卡员工")
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "vessel" },
                                                    _vm._l(
                                                      _vm.personalitySubCardEmployeeList,
                                                      function(item, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticClass:
                                                              "market"
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.employeeName
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "market-info"
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v("销售")
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  [
                                                                    item.achievement
                                                                      ? [
                                                                          _c(
                                                                            "input",
                                                                            {
                                                                              directives: [
                                                                                {
                                                                                  name:
                                                                                    "model",
                                                                                  rawName:
                                                                                    "v-model",
                                                                                  value:
                                                                                    item.achievement,
                                                                                  expression:
                                                                                    "item.achievement"
                                                                                }
                                                                              ],
                                                                              attrs: {
                                                                                type:
                                                                                  "text",
                                                                                disabled:
                                                                                  _vm.whetherToDisablePerformanceModification ||
                                                                                  item.brokerageClass ===
                                                                                    "no",
                                                                                onfocus:
                                                                                  "this.select()"
                                                                              },
                                                                              domProps: {
                                                                                value:
                                                                                  item.achievement
                                                                              },
                                                                              on: {
                                                                                input: function(
                                                                                  $event
                                                                                ) {
                                                                                  if (
                                                                                    $event
                                                                                      .target
                                                                                      .composing
                                                                                  ) {
                                                                                    return
                                                                                  }
                                                                                  _vm.$set(
                                                                                    item,
                                                                                    "achievement",
                                                                                    $event
                                                                                      .target
                                                                                      .value
                                                                                  )
                                                                                }
                                                                              }
                                                                            }
                                                                          )
                                                                        ]
                                                                      : [
                                                                          _c(
                                                                            "input",
                                                                            {
                                                                              directives: [
                                                                                {
                                                                                  name:
                                                                                    "model",
                                                                                  rawName:
                                                                                    "v-model",
                                                                                  value:
                                                                                    item.percentage,
                                                                                  expression:
                                                                                    "item.percentage"
                                                                                }
                                                                              ],
                                                                              attrs: {
                                                                                type:
                                                                                  "text",
                                                                                disabled:
                                                                                  _vm.whetherToDisablePerformanceModification ||
                                                                                  item.brokerageClass ===
                                                                                    "no",
                                                                                onfocus:
                                                                                  "this.select()"
                                                                              },
                                                                              domProps: {
                                                                                value:
                                                                                  item.percentage
                                                                              },
                                                                              on: {
                                                                                input: function(
                                                                                  $event
                                                                                ) {
                                                                                  if (
                                                                                    $event
                                                                                      .target
                                                                                      .composing
                                                                                  ) {
                                                                                    return
                                                                                  }
                                                                                  _vm.$set(
                                                                                    item,
                                                                                    "percentage",
                                                                                    $event
                                                                                      .target
                                                                                      .value
                                                                                  )
                                                                                }
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                    _vm._v(" "),
                                                                    item.brokerageClass !==
                                                                    "no"
                                                                      ? _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "iconfont icon-bianji1"
                                                                          }
                                                                        )
                                                                      : _vm._e()
                                                                  ],
                                                                  2
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", {
                                                              staticClass:
                                                                "iconfont icon-closel",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.deletePersonalitySubCardEmployees(
                                                                    index
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "particulars" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "particulars-title"
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "iconfont icon-dingdan"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v("付款方式")
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "paymentAmountStatistics"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "title-content-item"
                                                    },
                                                    [
                                                      _c("span", {
                                                        staticClass:
                                                          "iconfont icon-yingfu"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("订单金额：")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "amountType"
                                                            )(
                                                              _vm.memberCardPrice
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticStyle: {
                                                        color: "#1E90FF",
                                                        "font-size": "22px"
                                                      }
                                                    },
                                                    [_vm._v("【")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "title-content-item"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v("付现：")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "amountType"
                                                            )(_vm.actualCashPay)
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.existingRechargeCards &&
                                                            _vm
                                                              .existingRechargeCards
                                                              .length &&
                                                            _vm
                                                              .selectMembershipCardItems
                                                              .cardTypeCode ==
                                                              0 &&
                                                            !_vm.isNewMemberInfo,
                                                          expression:
                                                            "existingRechargeCards && existingRechargeCards.length&&selectMembershipCardItems.cardTypeCode==0&&!isNewMemberInfo"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "title-content-item"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v("可耗卡：")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "amountType"
                                                            )(_vm.haoCardMoney)
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "title-content-item",
                                                      staticStyle: {
                                                        display: "flex",
                                                        "align-items": "center",
                                                        margin: "0"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "margin-right":
                                                              "10px"
                                                          }
                                                        },
                                                        [_vm._v("优惠金额:")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            width: "80px",
                                                            height: "30px",
                                                            display: "flex"
                                                          }
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.memberCoupon,
                                                                expression:
                                                                  "memberCoupon"
                                                              }
                                                            ],
                                                            staticStyle: {
                                                              width: "100%",
                                                              height: "100%",
                                                              "border-radius":
                                                                "5px",
                                                              border:
                                                                "1px solid #E8E8E8",
                                                              "padding-left":
                                                                "10px",
                                                              "box-sizing":
                                                                "border-box"
                                                            },
                                                            attrs: {
                                                              type: "number",
                                                              onfocus:
                                                                "this.select()"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.memberCoupon
                                                            },
                                                            on: {
                                                              blur:
                                                                _vm.onPriceChanged,
                                                              input: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.memberCoupon =
                                                                  $event.target.value
                                                              }
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticStyle: {
                                                        color: "#1E90FF",
                                                        "font-size": "22px"
                                                      }
                                                    },
                                                    [_vm._v("】")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.departmentList === 1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "achievements"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v("部门业绩:")
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("div", [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "assigned"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle: {
                                                                      "padding-right":
                                                                        "10px",
                                                                      height:
                                                                        "28px",
                                                                      "line-height":
                                                                        "24px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "f20 text-primary"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "【"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _vm._l(
                                                                  _vm.isDepartmentalPerformance,
                                                                  function(
                                                                    item
                                                                  ) {
                                                                    return _c(
                                                                      "div",
                                                                      {
                                                                        key:
                                                                          item.departmentId,
                                                                        staticStyle: {
                                                                          "padding-right":
                                                                            "5px"
                                                                        }
                                                                      },
                                                                      [
                                                                        item.departmentName !==
                                                                        ""
                                                                          ? _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "text-primary"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        item.departmentName
                                                                                      ) +
                                                                                        ": "
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "el-input",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      width:
                                                                                        "50px"
                                                                                    },
                                                                                    attrs: {
                                                                                      size:
                                                                                        "mini",
                                                                                      oninput:
                                                                                        _vm.onInputNumPoint
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        item.achievement,
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          item,
                                                                                          "achievement",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                      expression:
                                                                                        "item.achievement"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          : _vm._e()
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "f20 text-primary"
                                                                  },
                                                                  [_vm._v("】")]
                                                                )
                                                              ],
                                                              2
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "order-content"
                                                },
                                                [
                                                  _vm._l(
                                                    _vm.clearingForm,
                                                    function(item) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: item.iconfont,
                                                          staticClass:
                                                            "order-content-item",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.topUpPaymentAmount(
                                                                item,
                                                                "openCard"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "typeOfPayment"
                                                            },
                                                            [
                                                              _c("span", [
                                                                _c(
                                                                  "svg",
                                                                  {
                                                                    staticClass:
                                                                      "icon",
                                                                    attrs: {
                                                                      "aria-hidden":
                                                                        "true"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("use", {
                                                                      attrs: {
                                                                        href:
                                                                          "#" +
                                                                          item.iconfont
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.name
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              item.paymentAmount >
                                                              0
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      class:
                                                                        item.name ===
                                                                          "智慧支付" &&
                                                                        _vm.globalPaymentStatus ===
                                                                          "1"
                                                                          ? "money active"
                                                                          : "money"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "amountType"
                                                                          )(
                                                                            item.paymentAmount
                                                                          )
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.amountOfConsumableCardNumber >
                                                    0 ||
                                                  _vm.canConsumeCardIncreaseGold >
                                                    0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "order-content-item"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "typeOfPayment"
                                                            },
                                                            [
                                                              _c("span", [
                                                                _c(
                                                                  "svg",
                                                                  {
                                                                    staticClass:
                                                                      "icon",
                                                                    attrs: {
                                                                      "aria-hidden":
                                                                        "true"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("use", {
                                                                      attrs: {
                                                                        href:
                                                                          "#icon-huiyuanqia"
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v(
                                                                  "智慧耗卡"
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "money"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "amountType"
                                                                        )(
                                                                          _vm.accuracyCheck(
                                                                            _vm.amountOfConsumableCardNumber,
                                                                            _vm.canConsumeCardIncreaseGold
                                                                          )
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass: "interval"
                                                  })
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "adjustedPayment"
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass: "cutOffRule"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "order-content-item",
                                                      on: {
                                                        click:
                                                          _vm.adjustedPayment
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "typeOfPayment"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _c(
                                                              "svg",
                                                              {
                                                                staticClass:
                                                                  "icon",
                                                                attrs: {
                                                                  "aria-hidden":
                                                                    "true"
                                                                }
                                                              },
                                                              [
                                                                _c("use", {
                                                                  attrs: {
                                                                    href:
                                                                      "#icon-hunhe"
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("调整支付")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-drawer",
                                  {
                                    attrs: {
                                      "append-to-body": true,
                                      size: "40%",
                                      "show-close": false,
                                      withHeader: false,
                                      "before-close":
                                        _vm.innerDrawerHandleClose,
                                      visible: _vm.innerDrawer
                                    },
                                    on: {
                                      "update:visible": function($event) {
                                        _vm.innerDrawer = $event
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "mixedPayment" }, [
                                      _c(
                                        "div",
                                        { staticClass: "mixedPayment-title" },
                                        [
                                          _c("span", [
                                            _vm._v("支付详情，共需支付："),
                                            _c("i", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("amountType")(
                                                    _vm.cashByPersonalCard
                                                  )
                                                )
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "iconfont icon-guanbi",
                                            on: {
                                              click: _vm.innerDrawerHandleClose
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "modeOfPaymentList" },
                                        _vm._l(
                                          _vm.modifyPaymentAmount,
                                          function(item) {
                                            return !(
                                              item.name === "耗卡本金" ||
                                              item.name === "耗卡赠金"
                                            ) || _vm.consumptionApplicable
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: item.name,
                                                    staticClass:
                                                      "modeOfPaymentList-item topUp"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "white-space":
                                                            "nowrap"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.name) +
                                                            ":"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: item.money,
                                                          expression:
                                                            "item.money"
                                                        }
                                                      ],
                                                      attrs: {
                                                        type: "text",
                                                        oninput:
                                                          "value=value.replace(/[^0-9.]/g,'')"
                                                      },
                                                      domProps: {
                                                        value: item.money
                                                      },
                                                      on: {
                                                        blur: function($event) {
                                                          item.name ===
                                                            "耗卡本金" ||
                                                          item.name ===
                                                            "耗卡赠金"
                                                            ? _vm.validateCardConsumption(
                                                                item
                                                              )
                                                            : _vm.excessOfAmount(
                                                                "openACard"
                                                              )
                                                        },
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            item,
                                                            "money",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    item.name === "智慧支付"
                                                      ? [
                                                          _c(
                                                            "span",
                                                            {
                                                              on: {
                                                                click:
                                                                  _vm.smartPayment
                                                              }
                                                            },
                                                            [_vm._v("支付")]
                                                          )
                                                        ]
                                                      : _vm._e()
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          }
                                        ),
                                        0
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-dialog",
                                  {
                                    attrs: {
                                      visible: _vm.topUpEmployeeShow,
                                      width: "50%",
                                      title: "选择员工",
                                      "append-to-body": true,
                                      "show-close": false,
                                      "before-close":
                                        _vm.closeTheMembershipScreeningPopup
                                    },
                                    on: {
                                      "update:visible": function($event) {
                                        _vm.topUpEmployeeShow = $event
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "employeeList" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "confirm",
                                          on: {
                                            click: function($event) {
                                              return _vm.firmChangeOrder(
                                                "openACard"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("确定")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "dataBox" },
                                        _vm._l(_vm.topUpEmployeeList, function(
                                          item
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: item.postName,
                                              staticClass: "con"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "position" },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "iconfont icon-zhiwei"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(item.postName)
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "staff" },
                                                _vm._l(
                                                  item.employeeDataList,
                                                  function(subItem) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: subItem.id,
                                                        class: subItem.label
                                                          ? "staff-item active"
                                                          : "staff-item",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.personalitySubCardSelectionOfEmployees(
                                                              subItem
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              subItem.employeeNo
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              subItem.employeeName
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _c(
                                                            "i",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    subItem.num,
                                                                  expression:
                                                                    "subItem.num"
                                                                }
                                                              ]
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  subItem.num
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("i", {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  subItem.num,
                                                                expression:
                                                                  "subItem.num"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "iconfont icon-chacha",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.deleteEmployeeData(
                                                                  subItem.id
                                                                )
                                                              }
                                                            }
                                                          })
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-drawer",
                                  {
                                    attrs: {
                                      "append-to-body": true,
                                      size: "40%",
                                      "show-close": true,
                                      withHeader: false,
                                      "before-close":
                                        _vm.closeTheScanCodePaymentWindow,
                                      visible: _vm.intelligentPaymentState
                                    },
                                    on: {
                                      "update:visible": function($event) {
                                        _vm.intelligentPaymentState = $event
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "smartPayment" }, [
                                      _c(
                                        "div",
                                        { staticClass: "wisdomPaysTitle" },
                                        [
                                          _c("span", [
                                            _vm._v("您当前正在通过")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "paymentMethodDetails"
                                            },
                                            [
                                              _c("span", [
                                                _c(
                                                  "svg",
                                                  {
                                                    staticClass: "icon",
                                                    attrs: {
                                                      "aria-hidden": "true"
                                                    }
                                                  },
                                                  [
                                                    _c("use", {
                                                      attrs: {
                                                        href: "#icon-shoukuan"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("span", [_vm._v("智慧支付")]),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: !_vm.innerDrawer,
                                                      expression: "!innerDrawer"
                                                    }
                                                  ]
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("amountType")(
                                                        _vm.clearingForm.reduce(
                                                          function(pv, cu) {
                                                            if (
                                                              cu.name ===
                                                              "智慧支付"
                                                            ) {
                                                              return _vm.accuracyCheck(
                                                                pv,
                                                                cu.paymentAmount
                                                              )
                                                            } else {
                                                              return pv
                                                            }
                                                          },
                                                          0
                                                        )
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.innerDrawer,
                                                      expression: "innerDrawer"
                                                    }
                                                  ]
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("amountType")(
                                                        _vm.modifyPaymentAmount.reduce(
                                                          function(pv, cu) {
                                                            if (
                                                              cu.name ===
                                                              "智慧支付"
                                                            ) {
                                                              return _vm.accuracyCheck(
                                                                pv,
                                                                cu.money
                                                              )
                                                            } else {
                                                              return pv
                                                            }
                                                          },
                                                          0
                                                        )
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "paymentModeSwitching" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                _vm.smartPaymentMethod === "0"
                                                  ? "active"
                                                  : "",
                                              on: {
                                                click: function($event) {
                                                  return _vm.switchingPaymentMethods(
                                                    "0",
                                                    "openCard"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("商家扫码收款")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              class:
                                                _vm.smartPaymentMethod === "1"
                                                  ? "active"
                                                  : "",
                                              on: {
                                                click: function($event) {
                                                  return _vm.switchingPaymentMethods(
                                                    "1",
                                                    "openCard"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("顾客扫码收款")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "collectionContents" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.smartPaymentMethod ===
                                                    "0",
                                                  expression:
                                                    "smartPaymentMethod === '0'"
                                                }
                                              ],
                                              staticClass:
                                                "merchantScanningCode"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "paymentContent"
                                                },
                                                [
                                                  _c("input", {
                                                    ref: "scanToPay",
                                                    attrs: {
                                                      type: "text",
                                                      placeholder:
                                                        "请使用扫码枪扫码输入",
                                                      oninput:
                                                        "value=value.replace(/[^0-9.]/g,'')"
                                                    },
                                                    domProps: {
                                                      value: _vm.codeNumber
                                                    },
                                                    on: {
                                                      keydown:
                                                        _vm.scanCodeGunInput
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [_vm._v("支付")])
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.smartPaymentMethod ===
                                                    "1",
                                                  expression:
                                                    "smartPaymentMethod === '1'"
                                                }
                                              ],
                                              staticClass: "customerScanCode"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "paymentContent"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "payBox" },
                                                    [
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              _vm.paymentCardPaymentAddress,
                                                            alt:
                                                              "暂无开通拉卡拉"
                                                          }
                                                        })
                                                      ],
                                                      _vm._v(" "),
                                                      _vm.payState === 100
                                                        ? [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "payImg"
                                                              },
                                                              [
                                                                _c("span", {
                                                                  staticClass:
                                                                    "iconfont icon-zhifuchenggong"
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    "支付中"
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        : _vm.payState === 300
                                                        ? [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "payImg"
                                                              },
                                                              [
                                                                _c("span", {
                                                                  staticClass:
                                                                    "iconfont icon-qunfengzhifuchenggong"
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    "支成功"
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        : _vm._e()
                                                    ],
                                                    2
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "payInfo" },
                                                    [
                                                      _c("span", [
                                                        _vm._v("扫码支付")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          "请顾客使用微信或支付宝扫此二维码"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ],
                              2
                            )
                          ]
                    ],
                    2
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.type === 5
            ? [_c("employeeRotation", { on: { handleClose: _vm.handleClose } })]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "部门业绩分配", visible: _vm.isInput, width: "30%" },
          on: {
            "update:visible": function($event) {
              _vm.isInput = $event
            }
          }
        },
        [
          _vm.DepartmentInput
            ? _c(
                "div",
                { staticClass: "inputShow" },
                [
                  _c("div", [
                    _c("h2", [
                      _c("span", [_vm._v("未分配:")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.totalCount))])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "line_between" }),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    _vm._l(_vm.isDepartmentalPerformance, function(i) {
                      return _c(
                        "el-form-item",
                        {
                          key: i.departmentId,
                          attrs: { label: i.departmentName }
                        },
                        [
                          i.departmentId
                            ? _c("el-input", {
                                staticStyle: { width: "100px" },
                                attrs: { oninput: _vm.onInputNumPoint },
                                model: {
                                  value: i.achievement,
                                  callback: function($$v) {
                                    _vm.$set(i, "achievement", $$v)
                                  },
                                  expression: "i.achievement"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "inputShow", staticStyle: { height: "200px" } },
                [
                  _c("div", [
                    _c("h2", [
                      _c("span", [_vm._v("未分配:")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.totalCount))])
                    ])
                  ])
                ]
              ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.isInput = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.isInputAddTo } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48cfc32e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48cfc32e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/paperless/components/orderPending.vue
// module id = null
// module chunks = 